import type { Dict } from "./types";

// Punjabi (ਪੰਜਾਬੀ) — flat dict covering every namespace/key from
// core.ts + owner.ts + tenant.ts's `en` blocks.
export const pa: Dict = {
  common: {
    save: "ਬਦਲਾਅ ਸੇਵ ਕਰੋ",
    saving: "ਸੇਵ ਹੋ ਰਿਹਾ ਹੈ…",
    cancel: "ਰੱਦ ਕਰੋ",
    remove: "ਹਟਾਓ",
    continue: "ਅੱਗੇ ਵਧੋ",
    somethingWrong: "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ",
    logOut: "ਲਾਗ ਆਊਟ",
    welcomeBackGreet: "ਵਾਪਸੀ 'ਤੇ ਸੁਆਗਤ ਹੈ,",
    hiGreet: "ਸਤਿ ਸ੍ਰੀ ਅਕਾਲ,",
    statusOpen: "ਖੁੱਲ੍ਹਾ",
    statusInProgress: "ਪ੍ਰਗਤੀ ਵਿੱਚ",
    statusResolved: "ਹੱਲ ਹੋ ਗਿਆ",
  },
  requests: {
    categoryLabel: "ਸ਼੍ਰੇਣੀ (ਵਿਕਲਪਿਕ)",
    categoryPlumbing: "ਪਲੰਬਿੰਗ",
    categoryElectrical: "ਇਲੈਕਟ੍ਰੀਕਲ",
    categoryAppliance: "ਉਪਕਰਣ",
    categoryFurniture: "ਫਰਨੀਚਰ",
    categoryCleaning: "ਸਫਾਈ",
    categoryPestControl: "ਪੈਸਟ ਕੰਟਰੋਲ",
    categoryOther: "ਹੋਰ",
    urgentCheckboxLabel: "ਇਹ ਜ਼ਰੂਰੀ ਹੈ",
    urgentBadge: "ਜ਼ਰੂਰੀ",
    photoLabel: "ਫੋਟੋ ਸ਼ਾਮਲ ਕਰੋ (ਵਿਕਲਪਿਕ)",
    addPhotoBtn: "ਫੋਟੋ ਸ਼ਾਮਲ ਕਰੋ",
    removePhotoAria: "ਫੋਟੋ ਹਟਾਓ",
    updatesHeading: "ਅੱਪਡੇਟਸ",
    noUpdatesYet: "ਹਾਲੇ ਤੱਕ ਕੋਈ ਅੱਪਡੇਟ ਨਹੀਂ।",
    addCommentPlaceholder: "ਇੱਕ ਨੋਟ ਸ਼ਾਮਲ ਕਰੋ…",
    postCommentBtn: "ਪੋਸਟ ਕਰੋ",
    postingCommentBtn: "ਪੋਸਟ ਹੋ ਰਿਹਾ ਹੈ…",
    callBtn: "ਕਾਲ ਕਰੋ",
    whatsappBtn: "ਵਟਸਐਪ",
  },
  nav: {
    home: "ਹੋਮ",
    listings: "ਲਿਸਟਿੰਗ",
    notebook: "ਨੋਟਬੁੱਕ",
    requests: "ਰਿਕਵੈਸਟ",
    settings: "ਸੈਟਿੰਗਸ",
    browse: "ਪ੍ਰਾਪਰਟੀ ਦੇਖੋ",
    payments: "ਪੇਮੈਂਟਸ",
    ownerDashboard: "ਮਾਲਕ ਡੈਸ਼ਬੋਰਡ",
    tenantDashboard: "ਕਿਰਾਏਦਾਰ ਡੈਸ਼ਬੋਰਡ",
  },
  auth: {
    welcomeEyebrow: "ਸੁਆਗਤ ਹੈ",
    welcomeTitle: "ToLetBook ਵਿੱਚ ਤੁਹਾਡਾ ਸੁਆਗਤ ਹੈ",
    welcomeSub: "ਆਪਣੇ ਅਕਾਊਂਟ ਵਿੱਚ ਲਾਗ ਇਨ ਕਰੋ, ਜਾਂ ਨਵਾਂ ਬਣਾਓ।",
    logIn: "ਲਾਗ ਇਨ ਕਰੋ",
    createAccount: "ਅਕਾਊਂਟ ਬਣਾਓ",
    loginTitle: "ਵਾਪਸੀ 'ਤੇ ਸੁਆਗਤ ਹੈ",
    loginSub: "ਆਪਣੇ ਡੈਸ਼ਬੋਰਡ 'ਤੇ ਜਾਣ ਲਈ ਲਾਗ ਇਨ ਕਰੋ।",
    registerTitle: "ਆਪਣਾ ਖਾਤਾ ਬਣਾਓ",
    registerSub: "ਇੱਕ ਜਾਇਦਾਦ ਸੂਚੀਬੱਧ ਕਰੋ ਜਾਂ ਆਪਣਾ ਅਗਲਾ ਘਰ ਲੱਭੋ — ਬਿਨਾਂ ਦਲਾਲਾਂ, ਬਿਨਾਂ ਪਰੇਸ਼ਾਨੀ।",
    passwordHint: "ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰ।",
    referralCodeLabel: "ਰੈਫਰਲ ਕੋਡ (ਵਿਕਲਪਿਕ)",
    referralCodePlaceholder: "ਜੇ ਤੁਹਾਡੇ ਕੋਲ ਕੋਡ ਹੈ ਤਾਂ ਦਰਜ ਕਰੋ",
    agreeTermsText: "ਮੈਂ ToLetBook ਦੇ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਅਤੇ ਪਰਾਈਵੇਸੀ ਨੀਤੀ ਨਾਲ ਸਹਿਮਤ ਹਾਂ",
    viewTermsLink: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਵੇਖੋ",
    viewPrivacyLink: "ਪਰਾਈਵੇਸੀ ਨੀਤੀ ਵੇਖੋ",
    hideTermsLink: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਲੁਕਾਓ",
    errMustAgreeTerms: "ਅੱਗੇ ਵਧਣ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਨਾਲ ਸਹਿਮਤ ਹੋਵੋ",
    loginBusy: "ਲਾਗ ਇਨ ਹੋ ਰਿਹਾ ਹੈ…",
    emailLabel: "ਈਮੇਲ",
    emailPlaceholder: "you@example.com",
    passwordLabel: "ਪਾਸਵਰਡ",
    passwordPlaceholder: "ਤੁਹਾਡਾ ਪਾਸਵਰਡ",
    errEmailPassword: "ਆਪਣੀ ਈਮੇਲ ਅਤੇ ਪਾਸਵਰਡ ਪਾਓ",
    getStartedEyebrow: "ਸ਼ੁਰੂ ਕਰੀਏ",
    roleTitle: "ਸਾਨੂੰ ਦੱਸੋ ਤੁਸੀਂ ਕੌਣ ਹੋ",
    roleSub: "ਤਾਂ ਜੋ ਅਸੀਂ ਤੁਹਾਡੇ ਲਈ ਸਹੀ ਡੈਸ਼ਬੋਰਡ ਤਿਆਰ ਕਰ ਸਕੀਏ।",
    roleOwnerTitle: "ਮੈਂ ਪ੍ਰਾਪਰਟੀ / ਪੀਜੀ ਮਾਲਕ ਹਾਂ",
    roleOwnerSub: "ਪ੍ਰਾਪਰਟੀ ਲਿਸਟ ਕਰੋ, ਕਿਰਾਏਦਾਰ ਮੈਨੇਜ ਕਰੋ, ਕਿਰਾਇਆ ਟਰੈਕ ਕਰੋ",
    roleTenantTitle: "ਮੈਂ ਕਿਰਾਏਦਾਰ ਹਾਂ",
    roleTenantSub: "ਲਿਸਟਿੰਗ ਦੇਖੋ, ਕਿਰਾਇਆ ਭਰੋ, ਰਿਕਵੈਸਟ ਭੇਜੋ",
    step1Eyebrow: "ਸਟੈਪ 1",
    credentialsTitle: "ਆਪਣਾ ਲਾਗਇਨ ਬਣਾਓ",
    newPasswordPlaceholder: "ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰ",
    phoneOptionalLabel: "ਮੋਬਾਈਲ ਨੰਬਰ (ਵਿਕਲਪਿਕ)",
    phonePlaceholder: "10 ਅੰਕਾਂ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ",
    errValidEmail: "ਸਹੀ ਈਮੇਲ ਪਤਾ ਪਾਓ",
    errPasswordLength: "ਪਾਸਵਰਡ ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰਾਂ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",
    errValidPhoneOptional: "10 ਅੰਕਾਂ ਦਾ ਸਹੀ ਮੋਬਾਈਲ ਨੰਬਰ ਪਾਓ, ਜਾਂ ਇਸਨੂੰ ਖਾਲੀ ਛੱਡ ਦਿਓ",
    step2Eyebrow: "ਸਟੈਪ 2",
    profileTitle: "ਆਪਣੇ ਬਾਰੇ ਥੋੜ੍ਹਾ ਦੱਸੋ",
    fullNameLabel: "ਪੂਰਾ ਨਾਂ",
    fullNamePlaceholder: "ਤੁਹਾਡਾ ਪੂਰਾ ਨਾਂ",
    profileBusy: "ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ…",
    errName: "ਆਪਣਾ ਨਾਂ ਪਾਓ",
    step3Eyebrow: "ਸਟੈਪ 3",
    propertyTypeTitle: "ਤੁਸੀਂ ਕੀ ਮੈਨੇਜ ਕਰਦੇ ਹੋ?",
    propertyTypeSub: "ਇਸ ਨਾਲ ਤੈਅ ਹੋਵੇਗਾ ਕਿ ਤੁਹਾਨੂੰ ਕਿਹੜਾ ਡੈਸ਼ਬੋਰਡ ਦਿਸੇਗਾ — ਇਸਨੂੰ ਬਾਅਦ ਵਿੱਚ ਬਦਲਿਆ ਜਾ ਸਕਦਾ ਹੈ।",
    typeIndependentTitle: "ਇੰਡੀਪੈਂਡੈਂਟ ਪ੍ਰਾਪਰਟੀ",
    typeIndependentSub: "ਪੂਰੇ ਘਰ, ਫਲੈਟ, ਵਿਲਾ",
    typePgTitle: "ਪੀਜੀ / ਹੋਸਟਲ",
    typePgSub: "ਬੈੱਡ ਦੇ ਹਿਸਾਬ ਨਾਲ ਕਿਰਾਏ ਵਾਲੇ ਸ਼ੇਅਰਡ ਕਮਰੇ",
    typeBothTitle: "ਦੋਵੇਂ",
    typeBothSub: "ਇੰਡੀਪੈਂਡੈਂਟ ਯੂਨਿਟਾਂ ਅਤੇ ਪੀਜੀ ਕਮਰਿਆਂ ਦਾ ਮਿਸ਼ਰਣ",
    almostDoneEyebrow: "ਲਗਭਗ ਹੋ ਗਿਆ",
    cityTitle: "ਤੁਸੀਂ ਕਿੱਥੇ ਕੰਮ ਕਰਦੇ ਹੋ?",
    citySub: "ਇਸ ਨਾਲ ਅਸੀਂ ਤੁਹਾਡੀ ਲਿਸਟਿੰਗ ਨੇੜਲੇ ਕਿਰਾਏਦਾਰਾਂ ਨੂੰ ਸਭ ਤੋਂ ਪਹਿਲਾਂ ਦਿਖਾਵਾਂਗੇ।",
    cityLabel: "ਸ਼ਹਿਰ",
    cityPlaceholder: "ਜਿਵੇਂ ਮੁੰਬਈ",
    bankDetailsTitle: "ਅਸੀਂ ਤੁਹਾਨੂੰ ਭੁਗਤਾਨ ਕਿਵੇਂ ਕਰੀਏ?",
    bankDetailsSub: "ਕਿਰਾਇਆ ਅਤੇ ਡਿਪਾਜ਼ਿਟ ਭੁਗਤਾਨ ਸਿੱਧੇ ਤੁਹਾਨੂੰ ਭੇਜੇ ਜਾ ਸਕਣ ਲਈ ਆਪਣਾ ਬੈਂਕ ਖਾਤਾ ਸ਼ਾਮਲ ਕਰੋ।",
    payoutMethodUpi: "UPI ID",
    payoutMethodBank: "ਬੈਂਕ ਖਾਤਾ",
    upiIdLabel: "UPI ID",
    upiIdPlaceholder: "ਜਿਵੇਂ name@okhdfcbank",
    errValidUpi: "ਸਹੀ UPI ID ਦਰਜ ਕਰੋ",
    bankAccountHolderLabel: "ਖਾਤਾਧਾਰਕ ਦਾ ਨਾਮ",
    bankAccountHolderPlaceholder: "ਬੈਂਕ ਰਿਕਾਰਡ ਅਨੁਸਾਰ",
    bankAccountNumberLabel: "ਖਾਤਾ ਨੰਬਰ",
    bankAccountNumberPlaceholder: "ਬੈਂਕ ਖਾਤਾ ਨੰਬਰ",
    bankIfscLabel: "IFSC ਕੋਡ",
    bankIfscPlaceholder: "ਜਿਵੇਂ HDFC0001234",
    bankDetailsHint: "ਤੁਸੀਂ ਇਸਨੂੰ ਕਿਸੇ ਵੀ ਸਮੇਂ ਸੈਟਿੰਗਾਂ ਤੋਂ ਸ਼ਾਮਲ ਜਾਂ ਬਦਲ ਸਕਦੇ ਹੋ।",
    skipForNowLink: "ਹੁਣੇ ਛੱਡੋ",
    errValidIfsc: "ਸਹੀ IFSC ਕੋਡ ਦਰਜ ਕਰੋ",
    finishBusy: "ਤਿਆਰ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ…",
    finish: "ਪੂਰਾ ਕਰੋ",
    doneTitle: "ਸਭ ਤਿਆਰ ਹੈ!",
    doneSub: "ਤੁਹਾਡਾ ਡੈਸ਼ਬੋਰਡ ਤਿਆਰ ਹੈ।",
    goToDashboard: "ਡੈਸ਼ਬੋਰਡ 'ਤੇ ਜਾਓ",
    welcomeBackToast: "ਵਾਪਸੀ 'ਤੇ ਸੁਆਗਤ ਹੈ, {name}!",
    welcomeNewToast: "ToLetBook ਵਿੱਚ ਤੁਹਾਡਾ ਸੁਆਗਤ ਹੈ, {name}!",
    orDivider: "ਜਾਂ",
    googleNoAccountToast: "ਉਸ Google ਈਮੇਲ ਲਈ ਕੋਈ ToLetBook ਅਕਾਊਂਟ ਨਹੀਂ ਮਿਲਿਆ — ਆਓ ਤੁਹਾਨੂੰ ਸੈਟ ਅੱਪ ਕਰੀਏ।",
    forgotPasswordLink: "ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ?",
    forgotPasswordEyebrow: "ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰੋ",
    forgotPasswordTitle: "ਆਪਣਾ ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ?",
    forgotPasswordSub: "ਆਪਣੀ ਈਮੇਲ ਪਾਓ ਅਤੇ ਅਸੀਂ ਤੁਹਾਨੂੰ ਇਸਨੂੰ ਰੀਸੈਟ ਕਰਨ ਲਈ ਇੱਕ ਲਿੰਕ ਭੇਜਾਂਗੇ।",
    forgotPasswordSubmit: "ਰੀਸੈਟ ਲਿੰਕ ਭੇਜੋ",
    forgotPasswordBusy: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ…",
    forgotPasswordSentTitle: "ਆਪਣੀ ਈਮੇਲ ਦੇਖੋ",
    forgotPasswordSentSub: "ਜੇ ਉਸ ਈਮੇਲ ਲਈ ਅਕਾਊਂਟ ਮੌਜੂਦ ਹੈ, ਤਾਂ ਅਸੀਂ ਤੁਹਾਡਾ ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰਨ ਲਈ ਇੱਕ ਲਿੰਕ ਭੇਜ ਦਿੱਤਾ ਹੈ।",
    resetPasswordEyebrow: "ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰੋ",
    resetPasswordTitle: "ਨਵਾਂ ਪਾਸਵਰਡ ਚੁਣੋ",
    resetPasswordSub: "ਇਹ ਲਿੰਕ 1 ਘੰਟੇ ਲਈ ਵੈਧ ਹੈ।",
    newPasswordLabel: "ਨਵਾਂ ਪਾਸਵਰਡ",
    confirmPasswordLabel: "ਨਵੇਂ ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
    errPasswordMismatch: "ਪਾਸਵਰਡ ਮੇਲ ਨਹੀਂ ਖਾਂਦੇ",
    resetPasswordSubmit: "ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰੋ",
    resetPasswordBusy: "ਰੀਸੈਟ ਹੋ ਰਿਹਾ ਹੈ…",
    resetPasswordDoneTitle: "ਪਾਸਵਰਡ ਰੀਸੈਟ ਹੋ ਗਿਆ",
    resetPasswordDoneSub: "ਹੁਣ ਤੁਸੀਂ ਆਪਣੇ ਨਵੇਂ ਪਾਸਵਰਡ ਨਾਲ ਲਾਗ ਇਨ ਕਰ ਸਕਦੇ ਹੋ।",
  },
  settings: {
    title: "ਸੈਟਿੰਗਸ",
    profileMenu: "ਪ੍ਰੋਫਾਈਲ",
    reportsMenu: "ਰਿਪੋਰਟਸ",
    plansMenu: "ਪਲਾਨ ਅਤੇ ਬਿਲਿੰਗ",
    referMenu: "ਰੈਫਰ ਕਰੋ ਅਤੇ ਕਮਾਓ",
    appearance: "ਥੀਮ",
    language: "ਭਾਸ਼ਾ",
    dark: "ਡਾਰਕ",
    light: "ਲਾਈਟ",
    termsTitle: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
    privacyTitle: "ਪਰਾਈਵੇਸੀ ਨੀਤੀ",
    bankDetailsMenu: "ਮੇਰੇ ਬੈਂਕ ਵੇਰਵੇ",
    bankDetailsHint: "ਇਹ ਵੇਰਵੇ ਤੁਹਾਨੂੰ ਸਿੱਧੇ ਕਿਰਾਇਆ ਅਤੇ ਡਿਪਾਜ਼ਿਟ ਭੁਗਤਾਨ ਭੇਜਣ ਲਈ ਵਰਤੇ ਜਾਂਦੇ ਹਨ। ਇਹ ਕਿਰਾਏਦਾਰਾਂ ਨੂੰ ਕਦੇ ਨਹੀਂ ਦਿਖਾਏ ਜਾਂਦੇ।",
    bankDetailsSaved: "ਬੈਂਕ ਵੇਰਵੇ ਸੇਵ ਹੋ ਗਏ",
    contactUsMenu: "ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    emailUsedToLogIn: "ਈਮੇਲ (ਲਾਗ ਇਨ ਲਈ ਵਰਤੀ ਜਾਂਦੀ ਹੈ)",
    name: "ਨਾਂ",
    phone: "ਫੋਨ ਨੰਬਰ",
    phonePlaceholder: "10 ਅੰਕਾਂ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ",
    city: "ਸ਼ਹਿਰ",
    profileUpdated: "ਪ੍ਰੋਫਾਈਲ ਅੱਪਡੇਟ ਹੋ ਗਈ",
    demoNotice: "ਇੱਥੇ ਦੇ ਅਕਾਊਂਟ ਸਿਰਫ਼ ਡੈਮੋ ਲਈ ਹਨ; ਕੋਈ ਵੀ ਈਮੇਲ ਅਤੇ ਪਾਸਵਰਡ ਵਰਤੋ।",
    verificationTitle: "ਪਛਾਣ ਤਸਦੀਕ",
    verificationHint: "ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਅਤੇ ਲਿਸਟਿੰਗ 'ਤੇ ਵੈਰੀਫਾਈਡ ਬੈਜ ਪਾਉਣ ਲਈ ਸਰਕਾਰੀ ਪਛਾਣ ਪੱਤਰ (ਅੱਗੇ ਅਤੇ ਪਿੱਛੇ) ਅੱਪਲੋਡ ਕਰੋ।",
    verificationSubmit: "ਤਸਦੀਕ ਲਈ ਭੇਜੋ",
    verificationSubmitted: "ਤਸਦੀਕ ਲਈ ਭੇਜ ਦਿੱਤਾ ਗਿਆ",
    errIdPhotosRequired: "ਆਪਣੇ ਪਛਾਣ ਪੱਤਰ ਦੇ ਅੱਗੇ ਅਤੇ ਪਿੱਛੇ ਦੋਵੇਂ ਪਾਸੇ ਸ਼ਾਮਲ ਕਰੋ",
    verificationVerified: "ਤੁਸੀਂ ਤਸਦੀਕਸ਼ੁਦਾ ਹੋ",
    verificationPending: "ਤਸਦੀਕ ਬਾਕੀ ਹੈ",
    verificationPendingSub: "ਸਮੀਖਿਆ ਹੁੰਦੇ ਹੀ ਅਸੀਂ ਤੁਹਾਨੂੰ ਦੱਸਾਂਗੇ — ਆਮ ਤੌਰ 'ਤੇ ਇੱਕ-ਦੋ ਦਿਨਾਂ ਵਿੱਚ।",
    verificationRejected: "ਤਸਦੀਕ ਮਨਜ਼ੂਰ ਨਹੀਂ ਹੋਈ",
    changePasswordTitle: "ਪਾਸਵਰਡ ਬਦਲੋ",
    currentPasswordLabel: "ਮੌਜੂਦਾ ਪਾਸਵਰਡ",
    errCurrentPasswordRequired: "ਆਪਣਾ ਮੌਜੂਦਾ ਪਾਸਵਰਡ ਪਾਓ",
    passwordChanged: "ਪਾਸਵਰਡ ਬਦਲ ਗਿਆ",
    changePasswordButton: "ਪਾਸਵਰਡ ਅੱਪਡੇਟ ਕਰੋ",
  },
  notifications: {
    title: "ਨੋਟੀਫਿਕੇਸ਼ਨ",
    enabledToast: "ਨੋਟੀਫਿਕੇਸ਼ਨ ਚਾਲੂ ਕੀਤੇ ਗਏ",
    disabledToast: "ਨੋਟੀਫਿਕੇਸ਼ਨ ਬੰਦ ਕੀਤੇ ਗਏ",
    couldNotEnableToast: "ਨੋਟੀਫਿਕੇਸ਼ਨ ਚਾਲੂ ਨਹੀਂ ਹੋ ਸਕੇ",
    notConfigured: "ਇਸ ਸਰਵਰ 'ਤੇ ਨੋਟੀਫਿਕੇਸ਼ਨ ਹਾਲੇ ਸੈੱਟਅੱਪ ਨਹੀਂ ਹੋਏ",
    deniedHint: "ਤੁਹਾਡੀ ਡਿਵਾਈਸ ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਇਸ ਐਪ ਲਈ ਨੋਟੀਫਿਕੇਸ਼ਨ ਬਲਾਕ ਹਨ।",
    markAllRead: "ਸਭ ਨੂੰ ਪੜ੍ਹਿਆ ਹੋਇਆ ਨਿਸ਼ਾਨਬੱਧ ਕਰੋ",
    emptyState: "ਹਾਲੇ ਤੱਕ ਕੋਈ ਨੋਟੀਫਿਕੇਸ਼ਨ ਨਹੀਂ।",
  },
  refer: {
    title: "ਰੈਫਰ ਕਰੋ ਅਤੇ ਕਮਾਓ",
    heroTitle: "1 ਮਹੀਨਾ ਦਿਓ, 1 ਮਹੀਨਾ ਪਾਓ",
    heroSub: "ਆਪਣੇ ਦੋਸਤ ਨੂੰ ToLetBook 'ਤੇ ਸੱਦਾ ਦਿਓ। ਜਦੋਂ ਉਹ ਐਪ ਡਾਊਨਲੋਡ ਕਰਕੇ ਸ਼ੁਰੂ ਕਰਨਗੇ — ਮਾਲਕ ਵਜੋਂ ਆਪਣੀ ਪਹਿਲੀ ਪ੍ਰਾਪਰਟੀ ਲਿਸਟ ਕਰਨ, ਜਾਂ ਕਿਰਾਏਦਾਰ ਵਜੋਂ ਆਪਣਾ ਪਹਿਲਾ ਸੰਪਰਕ ਅਨਲਾਕ ਕਰਨ — ਤਾਂ ਤੁਹਾਨੂੰ ਦੋਵਾਂ ਨੂੰ 1 ਮਹੀਨੇ ਦਾ Pro ਮੁਫ਼ਤ ਮਿਲੇਗਾ।",
    yourCodeLabel: "ਤੁਹਾਡਾ ਰੈਫਰਲ ਕੋਡ",
    shareButton: "ਸੱਦਾ ਸਾਂਝਾ ਕਰੋ",
    copiedToast: "ਰੈਫਰਲ ਲਿੰਕ ਕਾਪੀ ਹੋ ਗਿਆ",
    statsReferred: "{count} ਸੱਦੇ ਗਏ",
    statsRewarded: "{count} ਨੂੰ ਇਨਾਮ ਮਿਲਿਆ",
    statsRemaining: "{count} ਮੁਫ਼ਤ ਮਹੀਨੇ ਬਾਕੀ",
    howItWorksTitle: "ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ",
    step1: "ਆਪਣਾ ਕੋਡ ਜਾਂ ਲਿੰਕ ਕਿਸੇ ਦੋਸਤ ਨਾਲ ਸਾਂਝਾ ਕਰੋ",
    step2: "ਉਹ ToLetBook ਡਾਊਨਲੋਡ ਕਰਦੇ ਹਨ ਅਤੇ ਸਾਈਨ ਅੱਪ ਕਰਦੇ ਹਨ",
    step3: "ਉਹ ਮਾਲਕ ਵਜੋਂ ਪਹਿਲੀ ਪ੍ਰਾਪਰਟੀ ਲਿਸਟ ਕਰਦੇ ਹਨ, ਜਾਂ ਕਿਰਾਏਦਾਰ ਵਜੋਂ ਪਹਿਲਾ ਸੰਪਰਕ ਅਨਲਾਕ ਕਰਦੇ ਹਨ — ਤੁਹਾਨੂੰ ਦੋਵਾਂ ਨੂੰ 1 ਮਹੀਨੇ ਦਾ Pro ਮੁਫ਼ਤ ਮਿਲੇਗਾ",
    historyTitle: "ਤੁਹਾਡੇ ਰੈਫਰਲ",
    emptyState: "ਹਾਲੇ ਤੱਕ ਕੋਈ ਰੈਫਰਲ ਨਹੀਂ — ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਆਪਣਾ ਕੋਡ ਸਾਂਝਾ ਕਰੋ",
    statusPending: "ਉਹਨਾਂ ਦੀ ਪਹਿਲੀ ਲਿਸਟਿੰਗ ਦੀ ਉਡੀਕ ਹੈ",
    statusRewarded: "ਇਨਾਮ ਮਿਲਿਆ — 1 ਮਹੀਨਾ ਮੁਫ਼ਤ",
    statusCapped: "ਉਹਨਾਂ ਨੂੰ ਇਨਾਮ ਮਿਲਿਆ — ਤੁਹਾਡੀ ਸੀਮਾ ਪੂਰੀ ਹੋ ਗਈ",
    shareMessage: "ਮੇਰੇ ਨਾਲ ToLetBook 'ਤੇ ਸ਼ਾਮਲ ਹੋਵੋ! ਸਾਈਨ ਅੱਪ ਕਰਦੇ ਸਮੇਂ ਮੇਰਾ ਰੈਫਰਲ ਕੋਡ {code} ਵਰਤੋ — ਸਾਨੂੰ ਦੋਵਾਂ ਨੂੰ 1 ਮਹੀਨੇ ਦਾ Pro ਮੁਫ਼ਤ ਮਿਲੇਗਾ।",
  },
  ownerTerms: {
    intro: "ToLetBook ਵਰਤ ਕੇ ਤੁਸੀਂ ਇਹਨਾਂ ਸ਼ਰਤਾਂ ਨਾਲ ਸਹਿਮਤ ਹੁੰਦੇ ਹੋ।",
    bullet1: "ToLetBook ਰਾਹੀਂ ਕੀਤੇ ਗਏ ਕਿਰਾਏ ਅਤੇ ਡਿਪਾਜ਼ਿਟ ਦੇ ਭੁਗਤਾਨ Razorpay ਰਾਹੀਂ ਪ੍ਰੋਸੈਸ ਕੀਤੇ ਜਾਂਦੇ ਹਨ। ToLetBook ਕੋਈ ਬੈਂਕ ਨਹੀਂ ਹੈ ਅਤੇ Razorpay ਵੱਲੋਂ ਪੁਸ਼ਟੀ ਤੋਂ ਅੱਗੇ ਕਿਸੇ ਨਤੀਜੇ ਦੀ ਗਾਰੰਟੀ ਨਹੀਂ ਦਿੰਦਾ।",
    bullet2: "ਤੁਹਾਡੇ ਵੱਲੋਂ ਪਾਈ ਗਈ ਪ੍ਰਾਪਰਟੀ, ਕਿਰਾਏਦਾਰ ਅਤੇ ਭੁਗਤਾਨ ਦੀ ਜਾਣਕਾਰੀ ਸਹੀ ਹੋਣ ਦੀ ਜ਼ਿੰਮੇਵਾਰੀ ਤੁਹਾਡੀ ਹੈ।",
    bullet3: "ਤੁਹਾਡੇ ਵੱਲੋਂ ਪਾਈ ਗਈ ਪ੍ਰਾਪਰਟੀ, ਕਿਰਾਏਦਾਰ ਅਤੇ ਭੁਗਤਾਨ ਦੀ ਜਾਣਕਾਰੀ ਸਿਰਫ਼ ਇਸ ਡੈਮੋ ਲਈ ਸੇਵ ਹੁੰਦੀ ਹੈ, ਕਿਸੇ ਤੀਜੀ ਧਿਰ ਨਾਲ ਸਾਂਝੀ ਨਹੀਂ ਹੁੰਦੀ।",
    bullet4: "ਰਿਪੋਰਟਸ ਅਤੇ ਨੋਟਬੁੱਕ ਦੇ ਅੰਕੜੇ ਸਿੱਧੇ ਤੁਹਾਡੇ ਪਾਏ ਹੋਏ ਡੇਟਾ ਤੋਂ ਕੱਢੇ ਜਾਂਦੇ ਹਨ — ਆਡਿਟ ਜਾਂ ਸਤਿਆਪਿਤ ਨਹੀਂ ਹਨ।",
    bullet5: "ਮੈਪ ਅਤੇ ਲੋਕੇਸ਼ਨ ਸੁਵਿਧਾਵਾਂ Google Maps ਵੱਲੋਂ ਦਿੱਤੀਆਂ ਜਾਂਦੀਆਂ ਹਨ, ਜੋ Google ਦੀਆਂ ਆਪਣੀਆਂ ਸ਼ਰਤਾਂ ਦੇ ਅਧੀਨ ਹਨ।",
  },
  tenantTerms: {
    intro: "ToLetBook ਵਰਤ ਕੇ ਤੁਸੀਂ ਇਹਨਾਂ ਸ਼ਰਤਾਂ ਨਾਲ ਸਹਿਮਤ ਹੁੰਦੇ ਹੋ।",
    bullet1: "ToLetBook ਰਾਹੀਂ ਕੀਤੇ ਗਏ ਕਿਰਾਏ ਅਤੇ ਡਿਪਾਜ਼ਿਟ ਦੇ ਭੁਗਤਾਨ Razorpay ਰਾਹੀਂ ਪ੍ਰੋਸੈਸ ਕੀਤੇ ਜਾਂਦੇ ਹਨ। ToLetBook ਕੋਈ ਬੈਂਕ ਨਹੀਂ ਹੈ ਅਤੇ Razorpay ਵੱਲੋਂ ਪੁਸ਼ਟੀ ਤੋਂ ਅੱਗੇ ਕਿਸੇ ਨਤੀਜੇ ਦੀ ਗਾਰੰਟੀ ਨਹੀਂ ਦਿੰਦਾ।",
    bullet2: "ਤੁਹਾਡੇ ਵੱਲੋਂ ਦਿੱਤੀ ਗਈ ਜਾਣਕਾਰੀ ਸਹੀ ਹੋਣ ਦੀ ਜ਼ਿੰਮੇਵਾਰੀ ਤੁਹਾਡੀ ਹੈ।",
    bullet3: "ਤੁਹਾਡੇ ਵੱਲੋਂ ਪਾਈ ਗਈ ਪ੍ਰਾਪਰਟੀ, ਕਿਰਾਏਦਾਰ ਅਤੇ ਭੁਗਤਾਨ ਦੀ ਜਾਣਕਾਰੀ ਸਿਰਫ਼ ਇਸ ਡੈਮੋ ਲਈ ਸੇਵ ਹੁੰਦੀ ਹੈ, ਕਿਸੇ ਤੀਜੀ ਧਿਰ ਨਾਲ ਸਾਂਝੀ ਨਹੀਂ ਹੁੰਦੀ।",
    bullet4: "ਦਿਖਾਏ ਗਏ ਅੰਕੜੇ ਤੁਹਾਡੇ ਜਾਂ ਤੁਹਾਡੇ ਮਾਲਕ ਵੱਲੋਂ ਪਾਏ ਗਏ ਡੇਟਾ ਤੋਂ ਸਿੱਧੇ ਕੱਢੇ ਜਾਂਦੇ ਹਨ — ਆਡਿਟ ਜਾਂ ਸਤਿਆਪਿਤ ਨਹੀਂ ਹਨ।",
    bullet5: "ਮੈਪ ਅਤੇ ਲੋਕੇਸ਼ਨ ਸੁਵਿਧਾਵਾਂ Google Maps ਵੱਲੋਂ ਦਿੱਤੀਆਂ ਜਾਂਦੀਆਂ ਹਨ, ਜੋ Google ਦੀਆਂ ਆਪਣੀਆਂ ਸ਼ਰਤਾਂ ਦੇ ਅਧੀਨ ਹਨ।",
  },
  ownerHome: {
    sectionTitlePg: "ਤੁਹਾਡੇ ਪੀਜੀ",
    sectionTitleProperties: "ਤੁਹਾਡੀਆਂ ਪ੍ਰਾਪਰਟੀਆਂ",
    thisMonth: "ਇਸ ਮਹੀਨੇ",
    pctCollected: "{pct}% ਵਸੂਲਿਆ ਗਿਆ",
    received: "ਮਿਲਿਆ",
    pending: "ਬਕਾਇਆ",
    remindAll: "ਸਾਰਿਆਂ ਨੂੰ ਰਿਮਾਈਂਡ ਕਰੋ",
    remindersSent: "{count} ਕਿਰਾਏਦਾਰਾਂ ਨੂੰ ਰਿਮਾਈਂਡਰ ਭੇਜਿਆ ਗਿਆ",
    couldNotSendReminders: "ਰਿਮਾਈਂਡਰ ਭੇਜੇ ਨਹੀਂ ਜਾ ਸਕੇ",
    bedOccupancy: "ਬੈੱਡ ਓਕੂਪੈਂਸੀ",
    bedsFraction: "{filled}/{total} ਬੈੱਡ",
    acrossPg: "ਕੁੱਲ {count} ਪੀਜੀ {unit}",
    pgUnitSingular: "ਪ੍ਰਾਪਰਟੀ",
    pgUnitPlural: "ਪ੍ਰਾਪਰਟੀਆਂ",
    totalCount: "ਕੁੱਲ {count}",
    addPropertyAria: "ਪ੍ਰਾਪਰਟੀ ਜੋੜੋ",
    addUnitFab: "ਯੂਨਿਟ ਜੋੜੋ",
    sendWhatsappReceiptBtn: "WhatsApp ਰਸੀਦ ਭੇਜੋ",
    directUpiPayLinkBtn: "ਡਾਇਰੈਕਟ UPI ਪੇ ਲਿੰਕ",
    whatsappReceiptMessage: "ਹੈਲੋ {tenant}, {property} ਲਈ ਤੁਹਾਡੀ ਕਿਰਾਇਆ ਰਸੀਦ: {amount} ({status})। - {owner}, ToLetBook ਰਾਹੀਂ",
    upiPayLinkMessage: "ਹੈਲੋ {tenant}, ਕਿਰਪਾ ਕਰਕੇ {property} ਦਾ ਇਸ ਮਹੀਨੇ ਦਾ ਕਿਰਾਇਆ ({amount}) UPI ਰਾਹੀਂ ਭਰੋ: {link} - {owner}, ToLetBook ਰਾਹੀਂ",
    noTenantPhone: "ਇਸ ਕਿਰਾਏਦਾਰ ਦਾ ਫ਼ੋਨ ਨੰਬਰ ਦਰਜ ਨਹੀਂ ਹੈ",
    noUpiIdSet: "ਪਹਿਲਾਂ ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਆਪਣੀ UPI ID ਪਾਓ",
    tabProperty: "ਪ੍ਰਾਪਰਟੀ",
    tabPg: "ਪੀਜੀ",
    emptyNoProperties: "ਹਾਲੇ ਕੋਈ ਪ੍ਰਾਪਰਟੀ ਨਹੀਂ ਹੈ। ਆਪਣੀ ਪਹਿਲੀ ਪ੍ਰਾਪਰਟੀ ਜੋੜਨ ਲਈ + 'ਤੇ ਟੈਪ ਕਰੋ।",
    emptyNoIndependent: "ਹਾਲੇ ਕੋਈ ਇੰਡੀਪੈਂਡੈਂਟ ਪ੍ਰਾਪਰਟੀ ਨਹੀਂ ਹੈ।",
    emptyNoPg: "ਹਾਲੇ ਕੋਈ ਪੀਜੀ ਪ੍ਰਾਪਰਟੀ ਨਹੀਂ ਹੈ।",
    emptyNoCommercial: "ਹਾਲੇ ਕੋਈ ਕਮਰਸ਼ੀਅਲ ਪ੍ਰਾਪਰਟੀ ਨਹੀਂ ਹੈ।",
    filterAll: "ਸਾਰੇ",
    filterResidential: "ਰੈਜ਼ੀਡੈਂਸ਼ੀਅਲ",
    filterCommercial: "ਕਮਰਸ਼ੀਅਲ",
    filterPg: "PG / ਹੋਸਟਲ",
    sqftSuffix: "ਵਰਗ ਫੁੱਟ",
    listedOnMarketplace: "ਮਾਰਕੀਟਪਲੇਸ 'ਤੇ ਲਿਸਟ ਕਰ ਦਿੱਤਾ ਗਿਆ",
    removedFromMarketplace: "ਮਾਰਕੀਟਪਲੇਸ ਤੋਂ ਹਟਾ ਦਿੱਤਾ ਗਿਆ",
    couldNotUpdateListing: "ਲਿਸਟਿੰਗ ਅੱਪਡੇਟ ਨਹੀਂ ਹੋ ਸਕੀ",
    rentUpdated: "ਕਿਰਾਇਆ ਅੱਪਡੇਟ ਹੋ ਗਿਆ",
    couldNotUpdateRent: "ਕਿਰਾਇਆ ਅੱਪਡੇਟ ਨਹੀਂ ਹੋ ਸਕਿਆ",
    maintenanceUpdated: "ਮੇਂਟੇਨੈਂਸ ਅੱਪਡੇਟ ਹੋ ਗਿਆ",
    couldNotUpdateMaintenance: "ਮੇਂਟੇਨੈਂਸ ਅੱਪਡੇਟ ਨਹੀਂ ਹੋ ਸਕਿਆ",
    paid: "ਭੁਗਤਾਨ ਹੋਇਆ",
    tenantLabel: "ਕਿਰਾਏਦਾਰ",
    perMonth: "/ਮਹੀਨਾ",
    phoneLabel: "ਫੋਨ",
    noPhoneOnFile: "ਫੋਨ ਨੰਬਰ ਦਰਜ ਨਹੀਂ ਹੈ",
    aadhaarLabel: "ਆਧਾਰ",
    depositLabel: "ਡਿਪਾਜ਼ਿਟ",
    moveInDateLabel: "ਮੂਵ-ਇਨ ਤਾਰੀਖ",
    hideManageOptions: "ਮੈਨੇਜ ਵਿਕਲਪ ਲੁਕਾਓ",
    manage: "ਮੈਨੇਜ ਕਰੋ",
    manageHouses: "ਘਰ ਮੈਨੇਜ ਕਰੋ",
    rentalAgreement: "ਰੈਂਟਲ ਐਗਰੀਮੈਂਟ",
    rentalReceipts: "ਰੈਂਟਲ ਰਸੀਦਾਂ",
    modifyRent: "ਕਿਰਾਇਆ ਬਦਲੋ",
    maintenanceMenu: "ਮੇਂਟੇਨੈਂਸ",
    removeTenant: "ਕਿਰਾਏਦਾਰ ਹਟਾਓ",
    newRentLabel: "ਨਵਾਂ ਕਿਰਾਇਆ / ਮਹੀਨਾ",
    save: "ਸੇਵ ਕਰੋ",
    maintenancePerMonthLabel: "ਮੇਂਟੇਨੈਂਸ / ਮਹੀਨਾ",
    vacantBadge: "ਖਾਲੀ",
    expectedRentLabel: "ਅਨੁਮਾਨਿਤ ਕਿਰਾਇਆ",
    depositSuffix: " · ਡਿਪਾਜ਼ਿਟ {amount}",
    maintenanceLine: "+ {amount}/ਮਹੀਨਾ ਮੇਂਟੇਨੈਂਸ",
    listOnToLet: "TO-LET ਮਾਰਕੀਟਪਲੇਸ 'ਤੇ ਲਿਸਟ ਕਰੋ",
    liveVisible: "ਲਾਈਵ · ਕਿਰਾਏਦਾਰਾਂ ਨੂੰ ਦਿਸੇਗਾ",
    notListedYet: "ਹਾਲੇ ਲਿਸਟ ਨਹੀਂ ਕੀਤਾ",
    toggleToLetAria: "TO-LET ਟੌਗਲ ਕਰੋ",
    addTenantButton: "ਕਿਰਾਏਦਾਰ ਜੋੜੋ",
    occBoys: "ਬੁਆਏਜ਼ ਪੀਜੀ",
    occGirls: "ਗਰਲਜ਼ ਪੀਜੀ",
    occCoEd: "ਕੋ-ਐਡ ਪੀਜੀ",
    occDefault: "ਪੀਜੀ",
    listVacantBedsToLet: "ਖਾਲੀ ਬੈੱਡ TO-LET 'ਤੇ ਲਿਸਟ ਕਰੋ",
    fullyOccupied: "ਪੂਰੀ ਤਰ੍ਹਾਂ ਭਰਿਆ ਹੋਇਆ · ਕੋਈ ਬੈੱਡ ਖਾਲੀ ਨਹੀਂ",
  },
  ownerListings: {
    propertyAdded: "ਪ੍ਰਾਪਰਟੀ ਜੋੜੀ ਗਈ",
    upgradeToastMsg: "ਤੁਸੀਂ ਆਪਣੇ ਪਲਾਨ ਦੀ ਲਿਸਟਿੰਗ ਸੀਮਾ 'ਤੇ ਪਹੁੰਚ ਗਏ ਹੋ — ਅੱਪਗ੍ਰੇਡ ਵਿਕਲਪਾਂ 'ਤੇ ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ।",
    heading: "ਮੇਰੀਆਂ ਪ੍ਰਾਪਰਟੀਆਂ",
    addLink: "+ ਜੋੜੋ ›",
    emptyState: "ਹਾਲੇ ਕੋਈ ਪ੍ਰਾਪਰਟੀ ਨਹੀਂ — ਆਪਣੀ ਪਹਿਲੀ ਪ੍ਰਾਪਰਟੀ ਜੋੜੋ।",
    confirmDelete: '"{label}" ਨੂੰ ਹਟਾਉਣਾ ਹੈ? ਇਸਨੂੰ ਵਾਪਸ ਨਹੀਂ ਲਿਆਂਦਾ ਜਾ ਸਕਦਾ।',
    propertyDeleted: "ਪ੍ਰਾਪਰਟੀ ਹਟਾ ਦਿੱਤੀ ਗਈ",
    confirmDeleteHouse: '"{label}" ਹਟਾਉਣਾ ਹੈ? ਇਸਨੂੰ ਵਾਪਸ ਨਹੀਂ ਲਿਆਂਦਾ ਜਾ ਸਕਦਾ।',
    houseRemoved: "ਘਰ ਹਟਾ ਦਿੱਤਾ ਗਿਆ",
    houseUpdated: "ਘਰ ਦੀ ਜਾਣਕਾਰੀ ਅੱਪਡੇਟ ਹੋਈ",
    listedOnMarketplace: "ਮਾਰਕੀਟਪਲੇਸ 'ਤੇ ਲਿਸਟ ਕਰ ਦਿੱਤਾ ਗਿਆ",
    removedFromMarketplace: "ਮਾਰਕੀਟਪਲੇਸ ਤੋਂ ਹਟਾ ਦਿੱਤਾ ਗਿਆ",
    couldNotUpdateListing: "ਲਿਸਟਿੰਗ ਅੱਪਡੇਟ ਨਹੀਂ ਹੋ ਸਕੀ",
    vacantBedsFraction: "{vacant} / {total} ਖਾਲੀ",
    listOnToLet: "TO-LET ਮਾਰਕੀਟਪਲੇਸ 'ਤੇ ਲਿਸਟ ਕਰੋ",
    listVacantBedsToLet: "ਖਾਲੀ ਬੈੱਡ TO-LET 'ਤੇ ਲਿਸਟ ਕਰੋ",
    liveVisible: "ਲਾਈਵ · ਕਿਰਾਏਦਾਰਾਂ ਨੂੰ ਦਿਸੇਗਾ",
    notListedYet: "ਹਾਲੇ ਲਿਸਟ ਨਹੀਂ ਕੀਤਾ",
    toggleToLetAria: "TO-LET ਟੌਗਲ ਕਰੋ",
    moreOptionsAria: "ਹੋਰ ਵਿਕਲਪ",
    editDetails: "ਵੇਰਵੇ ਐਡਿਟ ਕਰੋ",
    deleteProperty: "ਪ੍ਰਾਪਰਟੀ ਹਟਾਓ",
    expectedRentLabel: "ਅਨੁਮਾਨਿਤ ਕਿਰਾਇਆ",
    depositLabel: "ਡਿਪਾਜ਼ਿਟ",
    noPhoneOnFile: "ਫੋਨ ਨੰਬਰ ਦਰਜ ਨਹੀਂ ਹੈ",
    perMonth: "/ਮਹੀਨਾ",
    endTenancyButton: "ਟੈਨੈਂਸੀ ਖਤਮ ਕਰੋ",
    editTenantButton: "ਕਿਰਾਏਦਾਰ ਨੂੰ ਮੋਡੀਫਾਈ ਕਰੋ",
    saveTenantButton: "ਬਦਲਾਅ ਸੇਵ ਕਰੋ",
    tenantAdded: "ਕਿਰਾਏਦਾਰ ਜੋੜਿਆ ਗਿਆ",
    tenantUpdated: "ਕਿਰਾਏਦਾਰ ਦੀ ਜਾਣਕਾਰੀ ਅੱਪਡੇਟ ਹੋਈ",
    roomAdded: "ਕਮਰਾ ਜੋੜਿਆ ਗਿਆ",
    couldNotAddRoom: "ਕਮਰਾ ਜੋੜਿਆ ਨਹੀਂ ਜਾ ਸਕਿਆ",
    addTenantLink: "+ ਕਿਰਾਏਦਾਰ ਜੋੜੋ",
    installAppPromptTitle: "{name} ਨੇ ਅਜੇ ਤੱਕ ToLetBook ਇੰਸਟਾਲ ਨਹੀਂ ਕੀਤਾ",
    installAppPromptBody: "ਐਪ ਸ਼ੇਅਰ ਕਰੋ ਤਾਂ ਜੋ ਉਹ ਆਪਣਾ ਐਗਰੀਮੈਂਟ ਦੇਖ ਸਕਣ ਅਤੇ ਮੂਵ-ਇਨ ਵੇਰਵੇ ਪੂਰੇ ਕਰ ਸਕਣ।",
    notifyTenantPromptTitle: "WhatsApp 'ਤੇ {name} ਨੂੰ ਦੱਸੋ",
    notifyTenantPromptBody: "ਇਹ ਸ਼ੇਅਰ ਕਰੋ ਤਾਂ ਜੋ ਉਹ ਐਪ ਖੋਲ੍ਹ ਕੇ ਮੂਵ-ਇਨ ਵੇਰਵੇ ਪੂਰੇ ਕਰ ਸਕਣ।",
    shareOnWhatsappBtn: "💬 WhatsApp 'ਤੇ ਸ਼ੇਅਰ ਕਰੋ",
    installAppWhatsappMessage: "ਹੈਲੋ, ਮੈਂ ToLetBook ਤੋਂ {owner} ਹਾਂ। ਮੈਂ ਤੁਹਾਨੂੰ \"{property}\" ਲਈ ਕਿਰਾਏਦਾਰ ਵਜੋਂ ਜੋੜਿਆ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਕਿਰਾਇਆ, ਐਗਰੀਮੈਂਟ ਦੇਖਣ ਅਤੇ ਮੂਵ-ਇਨ ਵੇਰਵੇ ਪੂਰੇ ਕਰਨ ਲਈ ਐਪ ਇੰਸਟਾਲ ਕਰੋ: {link}",
    notifyTenantWhatsappMessage: "ਹੈਲੋ, ਮੈਂ ToLetBook ਤੋਂ {owner} ਹਾਂ। ਮੈਂ ਤੁਹਾਨੂੰ \"{property}\" ਲਈ ਕਿਰਾਏਦਾਰ ਵਜੋਂ ਜੋੜਿਆ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਕਿਰਾਇਆ, ਐਗਰੀਮੈਂਟ ਦੇਖਣ ਅਤੇ ਮੂਵ-ਇਨ ਵੇਰਵੇ ਪੂਰੇ ਕਰਨ ਲਈ ਐਪ ਖੋਲ੍ਹੋ: {link}",
    editButton: "ਐਡਿਟ ਕਰੋ",
    deleteButton: "ਹਟਾਓ",
    perBed: "{amount}/ਬੈੱਡ",
    priceTiers: "{count} ਪ੍ਰਾਈਸ ਟੀਅਰ",
    occupiedFraction: "{occupied}/{total} ਭਰੇ ਹੋਏ",
    occupiedBadge: "ਭਰਿਆ ਹੋਇਆ",
    vacantBadge: "ਖਾਲੀ",
    rentalAgreementButton: "ਰੈਂਟਲ ਐਗਰੀਮੈਂਟ",
    rentalReceiptsButton: "ਕਿਰਾਏ ਦੀਆਂ ਰਸੀਦਾਂ",
    noReceiptsYet: "ਹਾਲੇ ਤੱਕ ਕੋਈ ਭੁਗਤਾਨ ਕੀਤੀ ਰਸੀਦ ਨਹੀਂ ਹੈ।",
    receiptsBackLink: "‹ ਵਾਪਸ",
    loadingReceipts: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…",
  },
  assignTenantForm: {
    contactPickerUnsupported: "ਇਸ ਡਿਵਾਈਸ/ਬ੍ਰਾਊਜ਼ਰ 'ਤੇ ਕੌਂਟੈਕਟ ਪਿਕਰ ਸਪੋਰਟ ਨਹੀਂ ਕਰਦਾ",
    errNameRequired: "ਕਿਰਾਏਦਾਰ ਦਾ ਨਾਂ ਜ਼ਰੂਰੀ ਹੈ",
    newTenant: "ਨਵਾਂ ਕਿਰਾਏਦਾਰ",
    existingTenant: "ਮੌਜੂਦਾ ਕਿਰਾਏਦਾਰ",
    addFromContacts: "ਕੌਂਟੈਕਟਸ ਤੋਂ ਜੋੜੋ",
    emptyExistingTenants: "ਤੁਹਾਡੀਆਂ ਪ੍ਰਾਪਰਟੀਆਂ 'ਤੇ ਹਾਲੇ ਕੋਈ ਹੋਰ ਕਿਰਾਏਦਾਰ ਨਹੀਂ ਹੈ।",
    noPhoneOnFile: "ਫੋਨ ਨੰਬਰ ਦਰਜ ਨਹੀਂ ਹੈ",
    tenantNameLabel: "ਕਿਰਾਏਦਾਰ ਦਾ ਨਾਂ",
    phoneLabel: "ਫੋਨ (ਜੇ ਰਜਿਸਟਰਡ ਹੈ, ਤਾਂ ਉਨ੍ਹਾਂ ਦੇ ToLetBook ਅਕਾਊਂਟ ਨਾਲ ਮੈਚ ਹੋਵੇਗਾ)",
    phonePlaceholder: "10 ਅੰਕਾਂ ਦਾ ਨੰਬਰ",
    aadhaarLabel: "ਆਧਾਰ (ਵਿਕਲਪਿਕ)",
    aadhaarPhotosLabel: "ਆਧਾਰ ਫੋਟੋਆਂ (ਵਿਕਲਪਿਕ)",
    aadhaarFront: "ਅੱਗੇ",
    aadhaarBack: "ਪਿੱਛੇ",
    removeAadhaarPhotoAria: "ਫੋਟੋ ਹਟਾਓ",
    rentLabel: "ਕਿਰਾਇਆ / ਮਹੀਨਾ",
    depositLabel: "ਡਿਪਾਜ਼ਿਟ",
    dateOfOccupancyLabel: "ਰਹਿਣ ਦੀ ਸ਼ੁਰੂਆਤ ਦੀ ਤਾਰੀਖ",
    dateHint: "ਜੇ ਉਹ ਪਹਿਲਾਂ ਤੋਂ ਇੱਥੇ ਰਹਿੰਦੇ ਹਨ, ਤਾਂ ਉਹ ਤਾਰੀਖ ਚੁਣੋ ਜਦੋਂ ਉਹ ਅਸਲ ਵਿੱਚ ਸ਼ਿਫਟ ਹੋਏ ਸਨ — ਅੱਜ ਦੀ ਨਹੀਂ।",
    rentDueDayLabel: "ਕਿਰਾਇਆ ਦੇਣ ਦੀ ਤਾਰੀਖ",
    rentDueDayHint: "ਮਹੀਨੇ ਦੀ ਉਹ ਤਾਰੀਖ ਜਦੋਂ ਕਿਰਾਇਆ ਦੇਣਾ ਹੈ (1–31)। ਡਿਫੌਲਟ ਰਹਿਣ ਦੀ ਸ਼ੁਰੂਆਤ ਦੀ ਤਾਰੀਖ ਹੁੰਦੀ ਹੈ।",
    noticePeriodLabel: "ਨੋਟਿਸ ਮਿਆਦ (ਦਿਨ)",
    noticePeriodHint: "ਕਿਰਾਏਦਾਰ ਨੂੰ ਖਾਲੀ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਕਿੰਨੇ ਦਿਨ ਦਾ ਨੋਟਿਸ ਦੇਣਾ ਪਵੇਗਾ। ਡਿਫੌਲਟ 60 ਦਿਨ (2 ਮਹੀਨੇ) ਹੁੰਦੇ ਹਨ।",
    addTenantButton: "ਕਿਰਾਏਦਾਰ ਜੋੜੋ",
  },
  addPropertyForm: {
    errNameRequired: "ਪ੍ਰਾਪਰਟੀ ਦਾ ਨਾਂ ਪਾਓ",
    errLocalityRequired: "ਇਲਾਕਾ ਦਰਜ ਕਰੋ",
    errCityRequired: "ਸ਼ਹਿਰ ਦਰਜ ਕਰੋ",
    errStateRequired: "ਰਾਜ ਚੁਣੋ",
    errPincodeRequired: "ਪਿਨਕੋਡ ਦਰਜ ਕਰੋ",
    errFurnishingRequired: "ਫਰਨਿਸ਼ਿੰਗ ਸਥਿਤੀ ਚੁਣੋ",
    errCommunityTypeRequired: "ਕਮਿਊਨਿਟੀ ਕਿਸਮ ਚੁਣੋ",
    errRentRequired: "ਅਨੁਮਾਨਿਤ ਕਿਰਾਇਆ ਦਰਜ ਕਰੋ",
    errDepositRequired: "ਅਨੁਮਾਨਿਤ ਡਿਪਾਜ਼ਿਟ ਦਰਜ ਕਰੋ",
    upgradeNowBtn: "ਹੁਣੇ ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
    heading: "ਪ੍ਰਾਪਰਟੀ ਜੋੜੋ",
    localityLabel: "ਇਲਾਕਾ",
    localityPlaceholder: "ਜਿਵੇਂ ਇੰਦਿਰਾਨਗਰ, ਬੰਗਲੌਰ",
    cityLabel: "ਸ਼ਹਿਰ",
    cityPlaceholder: "ਜਿਵੇਂ ਬੰਗਲੌਰ",
    stateLabel: "ਰਾਜ",
    statePlaceholder: "ਰਾਜ ਚੁਣੋ",
    pincodeLabel: "ਪਿੰਨਕੋਡ",
    pincodePlaceholder: "6 ਅੰਕਾਂ ਦਾ ਪਿੰਨਕੋਡ",
    chipIndependent: "ਇੰਡੀਪੈਂਡੈਂਟ",
    chipPgHostel: "ਪੀਜੀ / ਹੋਸਟਲ",
    chipCommercial: "ਕਮਰਸ਼ੀਅਲ",
    propertyNameLabel: "ਪ੍ਰਾਪਰਟੀ ਦਾ ਨਾਂ",
    propertyNamePlaceholder: "ਜਿਵੇਂ 3, ਰੋਜ਼ਵੁੱਡ ਅਪਾਰਟਮੈਂਟਸ",
    typeLabel: "ਟਾਈਪ",
    expectedRentLabel: "ਅਨੁਮਾਨਿਤ ਕਿਰਾਇਆ",
    expectedDepositLabel: "ਅਨੁਮਾਨਿਤ ਡਿਪਾਜ਼ਿਟ",
    maintenanceLabel: "ਮੇਂਟੇਨੈਂਸ / ਮਹੀਨਾ (ਵਿਕਲਪਿਕ)",
    maintenancePlaceholder: "ਜਿਵੇਂ 1500",
    multiUnitChip: "ਇਸ ਪ੍ਰਾਪਰਟੀ ਵਿੱਚ ਕਈ ਘਰ ਹਨ",
    multiUnitHint: "ਕਿਰਾਏ ਲਈ ਇੱਕ ਤੋਂ ਵੱਧ ਵੱਖਰੇ ਘਰ/ਫਲੈਟ ਵਾਲੇ ਕੰਪਾਊਂਡ ਜਾਂ ਬਿਲਡਿੰਗ ਲਈ — ਹਰੇਕ ਦਾ ਆਪਣਾ ਕਿਰਾਇਆ, ਡਿਪਾਜ਼ਿਟ ਅਤੇ ਕਿਰਾਏਦਾਰ ਹੋਵੇਗਾ।",
    commercialDetailsHeading: "ਕਮਰਸ਼ੀਅਲ ਵੇਰਵੇ",
    carpetAreaLabel: "ਕਾਰਪੇਟ ਏਰੀਆ (ਵਰਗ ਫੁੱਟ)",
    builtUpAreaLabel: "ਬਿਲਟ-ਅੱਪ ਏਰੀਆ (ਵਰਗ ਫੁੱਟ)",
    lockInMonthsLabel: "ਲਾਕ-ਇਨ ਮਿਆਦ (ਮਹੀਨੇ)",
    rentEscalationPercentLabel: "ਕਿਰਾਇਆ ਵਾਧਾ (%)",
    rentEscalationYearsLabel: "ਕਿੰਨੇ ਸਾਲਾਂ ਬਾਅਦ ਵਾਧਾ",
    possessionStatusLabel: "ਪਜ਼ੈਸ਼ਨ ਸਥਿਤੀ",
    possession_ready: "ਤੁਰੰਤ ਉਪਲਬਧ",
    possession_under_fitout: "ਫਿੱਟ-ਆਊਟ ਜਾਰੀ ਹੈ",
    washroomTypeLabel: "ਵਾਸ਼ਰੂਮ",
    washroom_attached: "ਅਟੈਚਡ",
    washroom_shared: "ਸ਼ੇਅਰਡ",
    commercialAmenitiesLabel: "ਸਹੂਲਤਾਂ",
    powerBackupChip: "ਪਾਵਰ ਬੈਕਅੱਪ",
    powerLoadDetailsLabel: "ਪਾਵਰ ਬੈਕਅੱਪ ਵੇਰਵੇ (ਵਿਕਲਪਿਕ)",
    powerLoadDetailsPlaceholder: "ਜਿਵੇਂ 3-ਫੇਜ਼, 100% DG ਬੈਕਅੱਪ",
    parkingSpotsLabel: "ਰਿਜ਼ਰਵਡ ਪਾਰਕਿੰਗ (ਕਾਰ/ਬਾਈਕ)",
    gstChip: "ਕਿਰਾਏ 'ਤੇ 18% GST ਲਾਗੂ",
    frontageChip: "ਫਰੰਟੇਜ / ਸਾਈਨੇਜ ਅਧਿਕਾਰ",
    seatsCountLabel: "ਸੀਟਾਂ",
    cabinsCountLabel: "ਕੈਬਿਨ",
    meetingRoomsCountLabel: "ਮੀਟਿੰਗ ਰੂਮ",
    housesHeading: "ਘਰ",
    addHouseLink: "+ ਘਰ ਜੋੜੋ ›",
    houseNameLabel: "ਘਰ ਦਾ ਨਾਂ",
    hasExistingTenantChip: "ਇਸ ਪ੍ਰਾਪਰਟੀ ਵਿੱਚ ਪਹਿਲਾਂ ਤੋਂ ਕਿਰਾਏਦਾਰ ਹੈ",
    tenantNameLabel: "ਕਿਰਾਏਦਾਰ ਦਾ ਨਾਂ",
    phoneLabel: "ਫੋਨ (ਜੇ ਰਜਿਸਟਰਡ ਹੈ, ਤਾਂ ਉਨ੍ਹਾਂ ਦੇ ToLetBook ਅਕਾਊਂਟ ਨਾਲ ਮੈਚ ਹੋਵੇਗਾ)",
    phonePlaceholder: "10 ਅੰਕਾਂ ਦਾ ਨੰਬਰ",
    aadhaarLabel: "ਆਧਾਰ (ਵਿਕਲਪਿਕ)",
    dateOfOccupancyLabel: "ਰਹਿਣ ਦੀ ਸ਼ੁਰੂਆਤ ਦੀ ਤਾਰੀਖ",
    dateHint: "ਜਦੋਂ ਉਹ ਅਸਲ ਵਿੱਚ ਸ਼ਿਫਟ ਹੋਏ — ਕਿਰਾਇਆ ਅਤੇ ਡਿਪਾਜ਼ਿਟ ਉੱਪਰ ਦਿੱਤੇ ਅਨੁਮਾਨਿਤ ਮੁੱਲ ਵਰਤਣਗੇ।",
    occupancyLabel: "ਓਕੂਪੈਂਸੀ",
    occBoys: "ਬੁਆਏਜ਼",
    occGirls: "ਗਰਲਜ਼",
    occCoEd: "ਕੋ-ਐਡ",
    roomsHeading: "ਕਮਰੇ",
    addRoomLink: "+ ਕਮਰਾ ਜੋੜੋ ›",
    sharingTypeLabel: "ਸ਼ੇਅਰਿੰਗ ਟਾਈਪ",
    rentPerBedLabel: "ਕਿਰਾਇਆ/ਬੈੱਡ",
    depositPerBedLabel: "ਡਿਪਾਜ਼ਿਟ/ਬੈੱਡ",
    bedsLabel: "ਬੈੱਡ",
    mealPlanLabel: "ਖਾਣਾ ਸ਼ਾਮਲ",
    preferredTenantsLabel: "ਪਸੰਦੀਦਾ ਕਿਰਾਏਦਾਰ",
    meal_breakfast: "ਬ੍ਰੇਕਫਾਸਟ",
    meal_lunch: "ਲੰਚ",
    meal_dinner: "ਡਿਨਰ",
    tenantType_student: "ਸਟੂਡੈਂਟ",
    tenantType_professional: "ਵਰਕਿੰਗ ਪ੍ਰੋਫੈਸ਼ਨਲ",
    roomAc: "ਏਸੀ",
    roomAttachedBathroom: "ਅਟੈਚਡ ਬਾਥਰੂਮ",
    addPropertyButton: "ਪ੍ਰਾਪਰਟੀ ਜੋੜੋ",
  },
  ownerLedgers: {
    justNow: "ਹੁਣੇ ਹੁਣੇ",
    minsAgo: "{mins} ਮਿੰਟ ਪਹਿਲਾਂ",
    hoursAgo: "{hours} ਘੰਟੇ ਪਹਿਲਾਂ",
    daysAgo: "{days} ਦਿਨ ਪਹਿਲਾਂ",
    emptyNoProperty: "ਨੋਟਬੁੱਕ ਟਰੈਕ ਕਰਨ ਲਈ ਪਹਿਲਾਂ ਇੱਕ ਪ੍ਰਾਪਰਟੀ ਜੋੜੋ।",
    heading: "ਨੋਟਬੁੱਕ",
    emptyNoTenants: "ਇੱਥੇ ਹਾਲੇ ਕੋਈ ਕਿਰਾਏਦਾਰ ਨਹੀਂ ਹੈ।",
    markedPaid: "ਭੁਗਤਾਨ ਹੋਇਆ ਵਜੋਂ ਮਾਰਕ ਕੀਤਾ ਗਿਆ",
    reminderSent: "ਕਿਰਾਏਦਾਰ ਨੂੰ ਰਿਮਾਈਂਡਰ ਭੇਜ ਦਿੱਤਾ ਗਿਆ",
    emptyNoActiveTenants: "ਇੱਥੇ ਹਾਲੇ ਕੋਈ ਐਕਟਿਵ ਕਿਰਾਏਦਾਰ ਨਹੀਂ ਹੈ।",
    otherCategory: "ਹੋਰ",
    pastTenantsHeading: "ਪੁਰਾਣੇ ਕਿਰਾਏਦਾਰ · {count}",
    rentLedgerLabel: "ਕਿਰਾਇਆ ਲੈਜਰ · ਪਿਛਲੇ 12 ਮਹੀਨੇ",
    paidFraction: "{paid}/{total} ਭੁਗਤਾਨ ਹੋਇਆ",
    entriesLabel: "ਐਂਟਰੀਆਂ",
    rentPaid: "ਕਿਰਾਇਆ ਮਿਲਿਆ",
    rentDue: "ਕਿਰਾਇਆ ਬਕਾਇਆ",
    markReceived: "ਮਿਲਿਆ ਮਾਰਕ ਕਰੋ (ਨਕਦ)",
    markingBusy: "ਮਾਰਕ ਹੋ ਰਿਹਾ ਹੈ…",
    remindAgain: "🔔 ਫੇਰ ਰਿਮਾਈਂਡ ਕਰੋ",
    remind: "🔔 ਰਿਮਾਈਂਡ ਕਰੋ",
    sendingBusy: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ…",
    remindedAgo: "{time} ਰਿਮਾਈਂਡ ਕੀਤਾ",
    closeButton: "‹ ਬੰਦ ਕਰੋ",
    refundLabel: "ਰਿਫੰਡ",
    refundedAmount: "{amount} ਰਿਫੰਡ ਕੀਤਾ ਗਿਆ",
  },
  ownerReports: {
    emptyState: "ਹਾਲੇ ਲੈਜਰ ਵਿੱਚ ਕੋਈ ਗਤੀਵਿਧੀ ਨਹੀਂ — ਵਸੂਲੀ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਕਿਰਾਏਦਾਰ ਜੋੜੋ।",
    heading: "ਰਿਪੋਰਟਸ",
    collected: "ਵਸੂਲਿਆ ਗਿਆ",
    pending: "ਬਕਾਇਆ",
    paidOnRecord: "ਰਿਕਾਰਡ 'ਤੇ ਭੁਗਤਾਨ",
    collectionsByMonth: "ਮਹੀਨੇ ਦੇ ਹਿਸਾਬ ਨਾਲ ਵਸੂਲੀ",
    monthTooltip: "{month}: {collected} ਵਸੂਲਿਆ ਗਿਆ, {pending} ਬਕਾਇਆ",
    byProperty: "ਪ੍ਰਾਪਰਟੀ ਦੇ ਹਿਸਾਬ ਨਾਲ",
    pendingAmount: "{amount} ਬਕਾਇਆ",
    exportCsvButton: "ਲੈਜਰ ਨੂੰ CSV ਵਜੋਂ ਐਕਸਪੋਰਟ ਕਰੋ",
    hint: "ਹਰ ਲਾਈਨ ਲੈਜਰ ਐਂਟਰੀ ਨਾਲ ਜੁੜੀ ਹੈ — ਇੱਥੇ ਕੋਈ ਵੱਖਰੇ ਅੰਕੜੇ ਨਹੀਂ ਜੋੜੇ ਗਏ।",
  },
  ownerRequests: {
    visitRequestsHeading: "ਵਿਜ਼ਿਟ ਰਿਕਵੈਸਟ",
    newCount: "{count} ਨਵੀਆਂ",
    emptyNoVisits: "ਹਾਲੇ ਕੋਈ ਵਿਜ਼ਿਟ ਰਿਕਵੈਸਟ ਨਹੀਂ ਹੈ।",
    maintenanceRequestsHeading: "ਮੇਂਟੇਨੈਂਸ ਰਿਕਵੈਸਟ",
    emptyNoRequests: "ਹਾਲੇ ਕੋਈ ਰਿਕਵੈਸਟ ਨਹੀਂ ਭੇਜੀ ਗਈ।",
    noDetailsProvided: "ਕੋਈ ਜਾਣਕਾਰੀ ਨਹੀਂ ਦਿੱਤੀ ਗਈ",
    startWork: "ਕੰਮ ਸ਼ੁਰੂ ਕਰੋ",
    markResolved: "ਹੱਲ ਹੋਇਆ ਮਾਰਕ ਕਰੋ",
    requestUpdated: "ਰਿਕਵੈਸਟ ਅੱਪਡੇਟ ਹੋ ਗਈ",
    visitConfirmed: "ਵਿਜ਼ਿਟ ਕਨਫਰਮ ਹੋ ਗਈ",
    visitDeclined: "ਵਿਜ਼ਿਟ ਅਸਵੀਕਾਰ ਕਰ ਦਿੱਤੀ ਗਈ",
    noPhoneOnFile: "ਫੋਨ ਨੰਬਰ ਦਰਜ ਨਹੀਂ ਹੈ",
    visitLine: "{property} · {date} ਨੂੰ {time} ਵਜੇ",
    declineButton: "ਅਸਵੀਕਾਰ ਕਰੋ",
    confirmButton: "ਕਨਫਰਮ ਕਰੋ",
    statusOpen: "ਖੁੱਲ੍ਹਾ",
    statusInProgress: "ਪ੍ਰਗਤੀ ਵਿੱਚ",
    statusResolved: "ਹੱਲ ਹੋ ਗਿਆ",
    visitStatusPending: "ਲੰਬਿਤ",
    visitStatusConfirmed: "ਕਨਫਰਮ",
    visitStatusDeclined: "ਅਸਵੀਕਾਰ ਕੀਤਾ",
    visitStatusCancelled: "ਰੱਦ",
    vacateRequestsHeading: "ਖਾਲੀ ਕਰਨ ਦੇ ਨੋਟਿਸ",
    emptyNoVacates: "ਹਾਲੇ ਕੋਈ ਖਾਲੀ ਕਰਨ ਦਾ ਨੋਟਿਸ ਨਹੀਂ ਹੈ।",
    vacateLine: "{property} · {date} ਨੂੰ ਖਾਲੀ ਕੀਤਾ ਜਾਵੇਗਾ",
    noticeGivenLine: "{date} ਨੂੰ ਨੋਟਿਸ ਦਿੱਤਾ ਗਿਆ",
    acknowledgeButton: "ਮਨਜ਼ੂਰ ਕਰੋ",
    vacateAcknowledged: "ਖਾਲੀ ਕਰਨ ਦਾ ਨੋਟਿਸ ਮਨਜ਼ੂਰ ਕੀਤਾ ਗਿਆ",
    vacateStatusPending: "ਲੰਬਿਤ",
    vacateStatusAcknowledged: "ਮਨਜ਼ੂਰ",
    vacateStatusCancelled: "ਰੱਦ",
  },
  editPropertyForm: {
    errNameRequired: "ਪ੍ਰਾਪਰਟੀ ਦਾ ਨਾਂ ਪਾਓ",
    propertyUpdated: "ਪ੍ਰਾਪਰਟੀ ਅੱਪਡੇਟ ਹੋ ਗਈ",
    couldNotUpdate: "ਪ੍ਰਾਪਰਟੀ ਅੱਪਡੇਟ ਨਹੀਂ ਹੋ ਸਕੀ",
    localityLabel: "ਇਲਾਕਾ",
    propertyNameLabel: "ਪ੍ਰਾਪਰਟੀ ਦਾ ਨਾਂ",
    typeLabel: "ਟਾਈਪ",
    residentialGroup: "ਰੈਜ਼ੀਡੈਂਸ਼ੀਅਲ",
    commercialGroup: "ਕਮਰਸ਼ੀਅਲ",
    expectedRentLabel: "ਅਨੁਮਾਨਿਤ ਕਿਰਾਇਆ",
    expectedDepositLabel: "ਅਨੁਮਾਨਿਤ ਡਿਪਾਜ਼ਿਟ",
    maintenanceLabel: "ਮੇਂਟੇਨੈਂਸ / ਮਹੀਨਾ (ਵਿਕਲਪਿਕ)",
    occupancyLabel: "ਓਕੂਪੈਂਸੀ",
    occBoys: "ਬੁਆਏਜ਼",
    occGirls: "ਗਰਲਜ਼",
    occCoEd: "ਕੋ-ਐਡ",
    facilitiesLabel: "ਸੁਵਿਧਾਵਾਂ",
    facility_wifi: "ਵਾਈ-ਫਾਈ",
    facility_meals: "ਖਾਣਾ",
    facility_laundry: "ਲਾਂਡਰੀ",
    facility_powerBackup: "ਪਾਵਰ ਬੈਕਅੱਪ",
    facility_cctv: "ਸੀਸੀਟੀਵੀ",
    facility_parking: "ਪਾਰਕਿੰਗ",
    facility_ac: "ਏਸੀ",
    facility_tv: "ਟੀਵੀ",
    facility_washingMachine: "ਵਾਸ਼ਿੰਗ ਮਸ਼ੀਨ",
    perHouseFurnishingHint: "ਫਰਨਿਸ਼ਿੰਗ ਹਰ ਘਰ ਲਈ ਵੱਖਰੇ ਤੌਰ 'ਤੇ ਸੈੱਟ ਕੀਤੀ ਜਾਂਦੀ ਹੈ — ਹੇਠਾਂ ਹਰ ਘਰ ਖੋਲ੍ਹ ਕੇ ਸੈੱਟ ਕਰੋ।",
    furnishingStatusLabel: "ਫਰਨਿਸ਼ਿੰਗ",
    furnishing_unfurnished: "ਅਨਫਰਨਿਸ਼ਡ",
    furnishing_semi_furnished: "ਸੈਮੀ-ਫਰਨਿਸ਼ਡ",
    furnishing_fully_furnished: "ਪੂਰੀ ਤਰ੍ਹਾਂ ਫਰਨਿਸ਼ਡ",
    commercialFurnishing_unfurnished: "ਬੇਅਰ ਸ਼ੈੱਲ",
    commercialFurnishing_semi_furnished: "ਵਾਰਮ ਸ਼ੈੱਲ",
    commercialFurnishing_fully_furnished: "ਪੂਰੀ ਤਰ੍ਹਾਂ ਫਰਨਿਸ਼ਡ",
    communityTypeLabel: "ਕਮਿਊਨਿਟੀ ਟਾਈਪ",
    community_gated: "ਗੇਟਿਡ ਕਮਿਊਨਿਟੀ",
    community_semi_gated: "ਸੈਮੀ ਗੇਟਿਡ ਕਮਿਊਨਿਟੀ",
    community_villa: "ਵਿਲਾ",
    community_apartment: "ਅਪਾਰਟਮੈਂਟ",
    community_independent: "ਇੰਡੀਪੈਂਡੈਂਟ",
    floorNumberLabel: "ਮੰਜ਼ਿਲ",
    floorNumberPlaceholder: "ਜਿਵੇਂ 3 ਜਾਂ ਗਰਾਊਂਡ",
    floorChipLabel: "ਮੰਜ਼ਿਲ {floor}",
    furnishingItemsLabel: "ਫਰਨੀਚਰ ਅਤੇ ਉਪਕਰਣ",
    furnishingItemsHint: "ਦੱਸੋ ਕਿ ਕਿਰਾਏਦਾਰ ਕੋਲ ਹਰ ਚੀਜ਼ ਦੀਆਂ ਕਿੰਨੀਆਂ ਹੋਣਗੀਆਂ।",
    item_fan: "ਪੱਖੇ",
    item_light: "ਲਾਈਟਾਂ",
    item_ac: "ਏਸੀ",
    item_fridge: "ਫਰਿੱਜ",
    item_washingMachine: "ਵਾਸ਼ਿੰਗ ਮਸ਼ੀਨ",
    item_sofa: "ਸੋਫਾ",
    item_bed: "ਬੈੱਡ",
    item_heater: "ਵਾਟਰ ਹੀਟਰ (ਬਾਥਰੂਮ)",
    item_chimney: "ਚਿਮਨੀ (ਕਿਚਨ)",
    addFurnitureItemPlaceholder: "+ ਫਰਨੀਚਰ / ਉਪਕਰਣ ਸ਼ਾਮਲ ਕਰੋ",
    customItemNamePlaceholder: "ਜਿਵੇਂ ਸਟੱਡੀ ਟੇਬਲ",
    addCustomItemBtn: "+ ਹੋਰ ਚੀਜ਼ ਸ਼ਾਮਲ ਕਰੋ",
  },
  endTenancyForm: {
    tenancyEnded: "ਟੈਨੈਂਸੀ ਖਤਮ ਹੋ ਗਈ — ਰਿਫੰਡ ਦੀ ਜਾਣਕਾਰੀ ਕਿਰਾਏਦਾਰ ਨੂੰ ਭੇਜ ਦਿੱਤੀ ਗਈ",
    couldNotEnd: "ਟੈਨੈਂਸੀ ਖਤਮ ਨਹੀਂ ਹੋ ਸਕੀ",
    heading: "ਟੈਨੈਂਸੀ ਖਤਮ ਕਰੋ — {name}",
    dateOfExitLabel: "ਛੱਡਣ ਦੀ ਤਾਰੀਖ",
    depositPaidLabel: "ਜਮ੍ਹਾਂ ਕੀਤਾ ਗਿਆ ਡਿਪਾਜ਼ਿਟ",
    deductionsLabel: "ਕਟੌਤੀ (ਨੁਕਸਾਨ, ਬਕਾਇਆ ਆਦਿ)",
    deductionNoteLabel: "ਕਟੌਤੀ ਦਾ ਨੋਟ (ਵਿਕਲਪਿਕ)",
    deductionNotePlaceholder: "ਜਿਵੇਂ ਕੰਧ ਦਾ ਪੇਂਟ ਠੀਕ ਕਰਵਾਉਣਾ",
    refundableDepositLabel: "ਵਾਪਸ ਮਿਲਣ ਵਾਲਾ ਡਿਪਾਜ਼ਿਟ",
    confirmButton: "ਕਨਫਰਮ ਕਰੋ ਅਤੇ ਟੈਨੈਂਸੀ ਖਤਮ ਕਰੋ",
    endingBusy: "ਖਤਮ ਹੋ ਰਿਹਾ ਹੈ…",
  },
  propertyPhotos: {
    uploadFailed: "ਅੱਪਲੋਡ ਨਹੀਂ ਹੋ ਸਕਿਆ",
    photoRemoved: "ਫੋਟੋ ਹਟਾ ਦਿੱਤੀ ਗਈ",
    couldNotRemove: "ਫੋਟੋ ਹਟਾਈ ਨਹੀਂ ਜਾ ਸਕੀ",
    removePhotoAria: "ਫੋਟੋ ਹਟਾਓ",
  },
  photoStager: {
    photosLabel: "ਫੋਟੋਆਂ (ਵਿਕਲਪਿਕ)",
    couldNotRead: "ਉਹ ਇਮੇਜ਼ ਪੜ੍ਹੀ ਨਹੀਂ ਜਾ ਸਕੀ",
    removePhotoAria: "ਫੋਟੋ ਹਟਾਓ",
  },
  photoPickerButtons: {
    addPhotoTitle: "ਫੋਟੋ ਜੋੜੋ",
    takePhoto: "📷 ਫੋਟੋ ਲਓ",
    chooseFromFiles: "🖼 ਫਾਈਲਾਂ ਤੋਂ ਚੁਣੋ",
  },
  ownerPlans: {
    title: "ਪਲਾਨ",
    currentPlanLabel: "ਮੌਜੂਦਾ ਪਲਾਨ",
    trialBadge: "ਮੁਫ਼ਤ ਪ੍ਰੀਮੀਅਮ ਟ੍ਰਾਇਲ",
    trialEndsOn: "ਟ੍ਰਾਇਲ {date} ਨੂੰ ਖਤਮ ਹੋਵੇਗਾ",
    renewsOn: "{date} ਨੂੰ ਰੀਨਿਊ ਹੋਵੇਗਾ",
    listingsUsed: "{cap} ਵਿੱਚੋਂ {used} ਲਿਸਟਿੰਗ ਵਰਤੀਆਂ",
    billingMonthly: "ਮਹੀਨਾਵਾਰ",
    billingYearly: "ਸਾਲਾਨਾ · ~16% ਬਚਤ",
    basicName: "ਬੇਸਿਕ",
    proName: "ਪ੍ਰੋ",
    premiumName: "ਪ੍ਰੀਮੀਅਮ",
    mostPopular: "ਸਭ ਤੋਂ ਮਸ਼ਹੂਰ",
    powerOwners: "ਪਾਵਰ ਮਾਲਕ",
    basicSub: "ਹੁਣੇ ਸ਼ੁਰੂਆਤ ਕਰ ਰਹੇ ਮਾਲਕਾਂ ਲਈ",
    proSub: "ਕੁਝ ਪ੍ਰਾਪਰਟੀਆਂ ਵਾਲੇ ਮਾਲਕਾਂ ਲਈ",
    premiumSub: "ਕਈ ਪ੍ਰਾਪਰਟੀਆਂ ਸੰਭਾਲਣ ਵਾਲੇ ਮਾਲਕਾਂ ਲਈ",
    featListing1: "1 ਐਕਟਿਵ ਲਿਸਟਿੰਗ",
    featListing3: "3 ਤੱਕ ਐਕਟਿਵ ਲਿਸਟਿੰਗਾਂ",
    featListingUnlimited: "ਅਸੀਮਤ ਲਿਸਟਿੰਗਾਂ",
    featEnquiries: "ਕਿਰਾਏਦਾਰ ਪੁੱਛਗਿੱਛ ਅਤੇ ਵਿਜ਼ਿਟ ਰਿਕਵੈਸਟ",
    featLedger: "ਕਿਰਾਇਆ ਵਸੂਲੀ ਅਤੇ ਡਿਜੀਟਲ ਲੈਜ਼ਰ",
    featAgreement: "ਸੈਲਫ-ਸਰਵ ਰੈਂਟਲ ਐਗਰੀਮੈਂਟ ਜਨਰੇਟਰ — ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ",
    featMarketplace: "TO-LET ਮਾਰਕੀਟਪਲੇਸ 'ਤੇ ਦਿਖਾਈ ਦਿੰਦਾ ਹੈ",
    featEverythingBasic: "ਬੇਸਿਕ ਦੀਆਂ ਸਾਰੀਆਂ ਸਹੂਲਤਾਂ",
    featEverythingPro: "ਪ੍ਰੋ ਦੀਆਂ ਸਾਰੀਆਂ ਸਹੂਲਤਾਂ",
    featMarketplaceSwitch: "TO-LET ਮਾਰਕੀਟਪਲੇਸ ਸਵਿੱਚ — ਕਦੇ ਵੀ ਲਾਈਵ ਕਰੋ",
    featFeatured: "ਸਰਚ ਵਿੱਚ ਫੀਚਰਡ ਪਲੇਸਮੈਂਟ",
    featPriority: "ਮਿਲਦੀਆਂ-ਜੁਲਦੀਆਂ ਪ੍ਰਾਪਰਟੀ ਸਲਾਹਾਂ ਵਿੱਚ ਤਰਜੀਹ",
    featTopListing: "ਟਾਪ ਲਿਸਟਿੰਗ — ਮਾਰਕੀਟਪਲੇਸ ਸਰਚ ਵਿੱਚ ਸਭ ਤੋਂ ਉੱਪਰ ਪਿੰਨ ਕੀਤੀ",
    featPriorityAgreement: "ਤਰਜੀਹੀ ਰੈਂਟਲ ਐਗਰੀਮੈਂਟ ਸੇਵਾ (ਕਾਨੂੰਨੀ ਤੌਰ 'ਤੇ ਸਮੀਖਿਅਤ, ਤੇਜ਼ ਟਰਨਅਰਾਊਂਡ) — ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ",
    featPriorityVerification: "ਤਰਜੀਹੀ ਪਛਾਣ-ਤਸਦੀਕ ਸਮੀਖਿਆ",
    featPrioritySupport: "ਤਰਜੀਹੀ ਸਹਾਇਤਾ",
    currentPlanBtn: "ਮੌਜੂਦਾ ਪਲਾਨ",
    switchToBtn: "{plan} 'ਤੇ ਸਵਿੱਚ ਕਰੋ",
    noChargeNote: "ਹਾਲੇ ਕੋਈ ਭੁਗਤਾਨ ਲੋੜੀਂਦਾ ਨਹੀਂ — ਬਿਲਿੰਗ ਸੈੱਟ ਹੋਣ ਤੱਕ ਪਲਾਨ ਬਦਲਣਾ ਮੁਫ਼ਤ ਹੈ।",
    switchedToast: "{plan} ਪਲਾਨ 'ਤੇ ਸਵਿੱਚ ਕੀਤਾ ਗਿਆ",
    switchFailedToast: "ਪਲਾਨ ਸਵਿੱਚ ਨਹੀਂ ਹੋ ਸਕਿਆ",
    trialActiveNote: "ਤੁਸੀਂ ਮੁਫ਼ਤ ਪ੍ਰੀਮੀਅਮ ਟ੍ਰਾਇਲ 'ਤੇ ਹੋ — ਇਹ ਖਤਮ ਹੋਣ ਤੱਕ ਹਰ ਪ੍ਰੀਮੀਅਮ ਫੀਚਰ ਅਨਲੌਕ ਹੈ।",
    cancelPlanBtn: "ਪਲਾਨ ਰੱਦ ਕਰੋ",
    securePaymentNote: "ਭੁਗਤਾਨ Razorpay ਰਾਹੀਂ ਸੁਰੱਖਿਅਤ ਢੰਗ ਨਾਲ ਪ੍ਰੋਸੈਸ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
  },
  tenantHome: {
    moveOutSettlement: "ਮੂਵ-ਆਊਟ ਸੈਟਲਮੈਂਟ",
    yourLastPlace: "ਤੁਹਾਡੀ ਪਿਛਲੀ ਜਗ੍ਹਾ",
    depositPaid: "ਜਮ੍ਹਾਂ ਕੀਤਾ ਗਿਆ ਡਿਪਾਜ਼ਿਟ",
    deductionsLabel: "ਕਟੌਤੀ",
    refundableDeposit: "ਵਾਪਸੀ ਯੋਗ ਡਿਪਾਜ਼ਿਟ",
    exitedOn: "{date} ਨੂੰ ਛੱਡਿਆ",
    noActiveTenancyLine1: "ਤੁਹਾਡੀ ਹਾਲੇ ਕੋਈ ਐਕਟਿਵ ਟੈਨੈਂਸੀ ਨਹੀਂ ਹੈ।",
    noActiveTenancyLine2: "ਰਹਿਣ ਦੀ ਜਗ੍ਹਾ ਲੱਭਣ ਲਈ ਲਿਸਟਿੰਗ ਦੇਖੋ, ਜਾਂ ਸ਼ਿਫਟ ਹੋਣ ਤੋਂ ਬਾਅਦ ਆਪਣੇ ਮਾਲਕ ਨੂੰ ਤੁਹਾਨੂੰ ਜੋੜਨ ਲਈ ਕਹੋ।",
    welcomeTitle: "ToLetBook ਵਿੱਚ ਤੁਹਾਡਾ ਸੁਆਗਤ ਹੈ!",
    welcomeSub: "ਤੁਹਾਡੇ ਲਈ ਕਿਰਾਏ ਦੀ ਪ੍ਰਾਪਰਟੀ ਲੱਭਦੇ ਹਾਂ।",
    browsePropertiesBtn: "ਪ੍ਰਾਪਰਟੀ ਦੇਖੋ",
    rentForMonth: "{month} ਦਾ ਕਿਰਾਇਆ",
    paidStatus: "ਭੁਗਤਾਨ ਹੋਇਆ",
    dueStatus: "ਬਕਾਇਆ",
    overdueStatus: "ਓਵਰਡਿਊ",
    dueInDays: "{count} ਦਿਨਾਂ ਵਿੱਚ ਦੇਣਾ ਹੈ",
    dueTodayLabel: "ਅੱਜ ਦੇਣਾ ਹੈ",
    overdueByDays: "{count} ਦਿਨ ਓਵਰਡਿਊ",
    reminderBanner: "🔔 ਤੁਹਾਡੇ ਮਾਲਕ ਨੇ ਇਸ ਭੁਗਤਾਨ ਬਾਰੇ ਰਿਮਾਈਂਡਰ ਭੇਜਿਆ ਹੈ",
    paidCheck: "✓ ਭੁਗਤਾਨ ਹੋਇਆ",
    onDate: "{date} ਨੂੰ",
    viaMode: "{mode} ਰਾਹੀਂ",
    receiptBtn: "ਰਸੀਦ",
    payingBtn: "ਭੁਗਤਾਨ ਹੋ ਰਿਹਾ ਹੈ…",
    payAmount: "{amount} ਭਰੋ",
    paymentRecordedToast: "ਭੁਗਤਾਨ ਦਰਜ ਹੋ ਗਿਆ",
    ownerLabel: "ਮਾਲਕ",
    callOwnerAria: "ਮਾਲਕ ਨੂੰ ਕਾਲ ਕਰੋ",
    raiseRequest: "ਰਿਕਵੈਸਟ ਭੇਜੋ",
    viewLease: "ਐਗਰੀਮੈਂਟ ਦੇਖੋ",
    receiptsNav: "ਰਸੀਦਾਂ",
    browseRooms: "ਕਮਰੇ ਦੇਖੋ",
    openRequestsHeading: "ਖੁੱਲ੍ਹੀਆਂ ਰਿਕਵੈਸਟਾਂ",
    viewAll: "ਸਾਰੀਆਂ ਦੇਖੋ",
    noOpenRequests: "ਕੋਈ ਖੁੱਲ੍ਹੀ ਰਿਕਵੈਸਟ ਨਹੀਂ ਹੈ।",
    noDetailsProvided: "ਕੋਈ ਵੇਰਵਾ ਨਹੀਂ ਦਿੱਤਾ ਗਿਆ",
  },
  tenantBrowse: {
    occBoys: "ਬੁਆਏਜ਼ ਪੀਜੀ",
    occGirls: "ਗਰਲਜ਼ ਪੀਜੀ",
    occCoEd: "ਕੋ-ਐਡ ਪੀਜੀ",
    occDefault: "ਪੀਜੀ",
    filterAll: "ਸਾਰੇ",
    filterPg: "ਪੀਜੀ",
    filter1RK: "1RK",
    filter1BHK: "1BHK",
    filter2BHK: "2BHK",
    filter3BHK: "3BHK",
    filterVilla: "ਵਿਲਾ",
    filterShop: "ਦੁਕਾਨ",
    filterOffice: "ਆਫਿਸ",
    filterShowroom: "ਸ਼ੋਰੂਮ",
    filterWarehouse: "ਗੋਦਾਮ",
    filterCoworking: "ਕੋ-ਵਰਕਿੰਗ",
    filterFactory: "ਫੈਕਟਰੀ",
    sortDefault: "ਡਿਫੌਲਟ",
    sortPriceAsc: "ਕੀਮਤ: ਘੱਟ ਤੋਂ ਵੱਧ",
    sortPriceDesc: "ਕੀਮਤ: ਵੱਧ ਤੋਂ ਘੱਟ",
    sortDistance: "ਦੂਰੀ: ਸਭ ਤੋਂ ਨੇੜੇ",
    locationNotSupported: "ਇਸ ਬ੍ਰਾਊਜ਼ਰ ਵਿੱਚ ਲੋਕੇਸ਼ਨ ਸਪੋਰਟ ਨਹੀਂ ਹੈ",
    locationPermissionDenied: "ਲੋਕੇਸ਼ਨ ਦੀ ਇਜਾਜ਼ਤ ਨਹੀਂ ਮਿਲੀ",
    locationCouldNotGet: "ਤੁਹਾਡੀ ਲੋਕੇਸ਼ਨ ਨਹੀਂ ਮਿਲ ਸਕੀ",
    heading: "ਤੁਹਾਡੇ ਲਈ ਕਿਰਾਏ ਦੀ ਜਗ੍ਹਾ ਲੱਭਦੇ ਹਾਂ",
    searchPlaceholder: "ਇਲਾਕੇ ਜਾਂ ਪ੍ਰਾਪਰਟੀ ਦੇ ਨਾਂ ਨਾਲ ਖੋਜੋ",
    filtersBtn: "⚙ ਫਿਲਟਰ",
    listView: "☰ ਲਿਸਟ ਵਿਊ",
    mapView: "🗺️ ਮੈਪ ਵਿਊ",
    fromPrice: "{price} ਤੋਂ ਸ਼ੁਰੂ",
    housesCount: "{count} ਘਰ",
    noVacancies: "ਹਾਲੇ ਕੋਈ ਖਾਲੀ ਜਗ੍ਹਾ ਨਹੀਂ ਹੈ — ਬਾਅਦ ਵਿੱਚ ਦੇਖੋ।",
    noMatch: "ਤੁਹਾਡੀ ਖੋਜ ਜਾਂ ਫਿਲਟਰ ਨਾਲ ਕੋਈ ਲਿਸਟਿੰਗ ਮੈਚ ਨਹੀਂ ਹੋਈ।",
    noPinnedLocation: "ਇਨ੍ਹਾਂ ਵਿੱਚੋਂ ਕਿਸੇ ਵੀ ਲਿਸਟਿੰਗ ਵਿੱਚ ਲੋਕੇਸ਼ਨ ਪਿਨ ਨਹੀਂ ਹੈ।",
    distanceAway: "{value} ਦੂਰ",
    filtersTitle: "ਫਿਲਟਰ",
    propertyTypeLabel: "ਪ੍ਰਾਪਰਟੀ ਟਾਈਪ",
    sortByLabel: "ਇਸ ਹਿਸਾਬ ਨਾਲ ਕ੍ਰਮ ਕਰੋ",
    yourLocationLabel: "ਤੁਹਾਡੀ ਲੋਕੇਸ਼ਨ",
    locating: "ਲੋਕੇਸ਼ਨ ਲੱਭੀ ਜਾ ਰਹੀ ਹੈ…",
    locationOn: "📍 ਲੋਕੇਸ਼ਨ ਆਨ ਹੈ",
    useMyLocation: "📍 ਮੇਰੀ ਲੋਕੇਸ਼ਨ ਵਰਤੋ",
    nearLabel: "📍 {location} ਦੇ ਨੇੜੇ",
    clearAll: "ਸਭ ਹਟਾਓ",
    showResults: "ਨਤੀਜੇ ਦਿਖਾਓ",
    backToListings: "‹ ਲਿਸਟਿੰਗ 'ਤੇ ਵਾਪਸ ਜਾਓ",
    housesHeading: "ਘਰ",
    occupiedBadge: "ਭਰਿਆ",
    vacantBadge: "ਖਾਲੀ",
    typeLabel: "ਟਾਈਪ",
    rentLabel: "ਕਿਰਾਇਆ",
    perMonthSuffix: "/ਮਹੀਨਾ",
    depositLabel: "ਡਿਪਾਜ਼ਿਟ",
    escalationLabel: "ਕਿਰਾਇਆ ਵਾਧਾ",
    yearsSuffix: "ਸਾਲ",
    occupancyLabel: "ਓਕੂਪੈਂਸੀ",
    mealPlanLabel: "ਖਾਣਾ ਸ਼ਾਮਲ",
    preferredTenantsLabel: "ਪਸੰਦੀਦਾ ਕਿਰਾਏਦਾਰ",
    roomAc: "ਏਸੀ",
    roomAttachedBathroom: "ਅਟੈਚਡ ਬਾਥਰੂਮ",
    bedsVacant: "{total} ਵਿੱਚੋਂ {vacant} ਬੈੱਡ ਖਾਲੀ",
    locationLabel: "ਲੋਕੇਸ਼ਨ",
    openInGoogleMaps: "Google Maps ਵਿੱਚ ਖੋਲ੍ਹੋ",
    viewOnMap: "ਮੈਪ 'ਤੇ ਵੇਖੋ",
    hideMap: "ਮੈਪ ਲੁਕਾਓ",
    showNearby: "ਨੇੜੇ ਕੀ ਹੈ ਵੇਖੋ",
    hideNearby: "ਨੇੜਲੀਆਂ ਥਾਵਾਂ ਲੁਕਾਓ",
    loadingNearby: "ਨੇੜਲੀਆਂ ਥਾਵਾਂ ਲੱਭੀਆਂ ਜਾ ਰਹੀਆਂ ਹਨ…",
    nearbyEmpty: "ਨੇੜੇ ਕੋਈ ਥਾਂ ਨਹੀਂ ਮਿਲੀ",
    nearbyTransit: "ਟ੍ਰਾਂਜ਼ਿਟ",
    nearbyEssentials: "ਜ਼ਰੂਰੀ ਵਸਤਾਂ",
    nearbyHealthcare: "ਸਿਹਤ ਸੇਵਾ",
    metersAway: "{distance} ਮੀਟਰ ਦੂਰ",
    similarPropertiesHeading: "ਮਿਲਦੀਆਂ-ਜੁਲਦੀਆਂ ਪ੍ਰਾਪਰਟੀਆਂ",
    topTag: "ਟਾਪ",
    featuredTag: "ਫੀਚਰਡ",
    moveInHint: "ਸ਼ਿਫਟ ਹੋਣ ਲਈ, ਮਾਲਕ ਨੂੰ ਆਪਣੇ ਰਜਿਸਟਰਡ ਫੋਨ ਨੰਬਰ ਨਾਲ ਤੁਹਾਨੂੰ ਕਿਰਾਏਦਾਰ ਵਜੋਂ ਜੋੜਨ ਲਈ ਕਹੋ — ਫੇਰ ਇਹ ਆਪਣੇ ਆਪ ਤੁਹਾਡੇ ਹੋਮ ਟੈਬ ਵਿੱਚ ਦਿਸਣ ਲੱਗੇਗਾ।",
    scheduleVisit: "ਵਿਜ਼ਿਟ ਸ਼ੈਡਿਊਲ ਕਰੋ",
    pickDateTime: "ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ ਚੁਣੋ",
    visitRequestSent: "ਵਿਜ਼ਿਟ ਰਿਕਵੈਸਟ ਮਾਲਕ ਨੂੰ ਭੇਜ ਦਿੱਤੀ ਗਈ",
    couldNotSendVisit: "ਵਿਜ਼ਿਟ ਰਿਕਵੈਸਟ ਨਹੀਂ ਭੇਜੀ ਜਾ ਸਕੀ",
    requestedFor: "{date} ਨੂੰ {time} ਵਜੇ ਲਈ ਰਿਕਵੈਸਟ ਭੇਜੀ ਗਈ — ਮਾਲਕ ਨੂੰ ਸੂਚਿਤ ਕਰ ਦਿੱਤਾ ਗਿਆ ਹੈ, ਉਹ ਪੁਸ਼ਟੀ ਕਰਨਗੇ।",
    dateLabel: "ਤਾਰੀਖ",
    timeLabel: "ਸਮਾਂ",
    noteOptionalLabel: "ਨੋਟ (ਵਿਕਲਪਿਕ)",
    notePlaceholder: "ਜਿਵੇਂ ਸ਼ਾਮ ਨੂੰ ਆਉਣਾ ਪਸੰਦ ਹੈ, ਪਹਿਲਾਂ ਕਾਲ ਕਰਾਂਗਾ",
    sending: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ…",
    requestVisitBtn: "ਵਿਜ਼ਿਟ ਰਿਕਵੈਸਟ ਕਰੋ",
    ownerContactLabel: "ਮਾਲਕ",
    verifiedOwnerBadge: "ਤਸਦੀਕਸ਼ੁਦਾ",
    unlockingBtn: "ਅਨਲੌਕ ਹੋ ਰਿਹਾ ਹੈ…",
    unlockNumberFreeBtn: "🔓 ਨੰਬਰ ਅਨਲੌਕ ਕਰੋ — ਮੁਫ਼ਤ",
    unlockUpsellTitle: "ਮੁਫ਼ਤ ਅਨਲੌਕ ਵਰਤਿਆ ਜਾ ਚੁੱਕਾ ਹੈ",
    unlockUpsellBody: "ਬੇਸਿਕ ਪਲਾਨ ਵਿੱਚ 1 ਮਾਲਕ ਦਾ ਕਾਂਟੈਕਟ ਮੁਫ਼ਤ ਅਨਲੌਕ ਹੁੰਦਾ ਹੈ। ਅਸੀਮਤ ਮਾਲਕਾਂ ਨੂੰ ਅਨਲੌਕ ਕਰਨ ਲਈ Tenant Pro ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ।",
    unlockUpsellBtn: "Tenant Pro ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
    callNumberBtn: "{phone} 'ਤੇ ਕਾਲ ਕਰੋ",
    whatsappBtn: "💬 WhatsApp 'ਤੇ ਚੈਟ ਕਰੋ",
    whatsappMessage: "ਹੈਲੋ, ਮੈਨੂੰ ToLetBook 'ਤੇ ਲਿਸਟ ਕੀਤੀ ਤੁਹਾਡੀ ਪ੍ਰਾਪਰਟੀ \"{property}\" ਵਿੱਚ ਦਿਲਚਸਪੀ ਹੈ। ਕੀ ਇਹ ਹਾਲੇ ਵੀ ਉਪਲਬਧ ਹੈ?",
    contactUnlockedToast: "ਕੌਂਟੈਕਟ ਨੰਬਰ ਅਨਲੌਕ ਹੋ ਗਿਆ",
    couldNotUnlockToast: "ਕੌਂਟੈਕਟ ਅਨਲੌਕ ਨਹੀਂ ਹੋ ਸਕਿਆ",
  },
  tenantPayments: {
    noActiveTenancy: "ਤੁਹਾਡੀ ਕੋਈ ਐਕਟਿਵ ਟੈਨੈਂਸੀ ਨਹੀਂ ਹੈ ਜਿਸਦਾ ਕਿਰਾਇਆ ਭਰਿਆ ਜਾਵੇ।",
    title: "ਪੇਮੈਂਟਸ",
    paidStatus: "ਭੁਗਤਾਨ ਹੋਇਆ",
    rentDue: "ਕਿਰਾਇਆ ਬਕਾਇਆ ਹੈ",
    reminderBanner: "🔔 ਤੁਹਾਡੇ ਮਾਲਕ ਨੇ ਇਸ ਭੁਗਤਾਨ ਬਾਰੇ ਰਿਮਾਈਂਡਰ ਭੇਜਿਆ ਹੈ",
    payingBtn: "ਭੁਗਤਾਨ ਹੋ ਰਿਹਾ ਹੈ…",
    payViaUpi: "UPI ਰਾਹੀਂ {amount} ਭਰੋ",
    payNow: "{amount} ਭਰੋ",
    paymentFailedToast: "ਭੁਗਤਾਨ ਨਹੀਂ ਹੋਇਆ — ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    paymentRecordedToast: "ਭੁਗਤਾਨ ਦਰਜ ਹੋ ਗਿਆ",
    viewReceiptBtn: "ਰਸੀਦ ਦੇਖੋ",
    history: "ਇਤਿਹਾਸ",
    payViaUpiDirectlyBtn: "ਸਿੱਧਾ UPI ਰਾਹੀਂ ਭੁਗਤਾਨ ਕਰੋ",
    ownerUpiIdLabel: "ਮਾਲਕ ਦਾ UPI ID",
    copyUpiBtn: "ਕਾਪੀ ਕਰੋ",
    upiIdCopiedToast: "UPI ID ਕਾਪੀ ਹੋ ਗਿਆ",
    openUpiAppBtn: "UPI ਐਪ ਖੋਲ੍ਹੋ",
    markPaidUpiBtn: "ਮੈਂ UPI ਰਾਹੀਂ ਭੁਗਤਾਨ ਕਰ ਦਿੱਤਾ ਹੈ",
    markPaidUpiConfirm: "ਕੀ ਤੁਸੀਂ ਇਹ ਕਿਰਾਇਆ ਮਾਲਕ ਦੇ UPI ID 'ਤੇ ਭੇਜ ਦਿੱਤਾ ਹੈ? ਇਸ ਨਾਲ ਇਹ ਭੁਗਤਾਨ ਹੋਇਆ ਵਜੋਂ ਦਰਜ ਹੋ ਜਾਵੇਗਾ।",
  },
  tenantRequests: {
    title: "ਮੇਂਟੇਨੈਂਸ ਰਿਕਵੈਸਟ",
    cancelLink: "ਰੱਦ ਕਰੋ ›",
    newLink: "+ ਨਵੀਂ ›",
    whatsWrong: "ਕੀ ਸਮੱਸਿਆ ਹੈ?",
    issuePlaceholder: "ਜਿਵੇਂ ਨਲ ਤੋਂ ਪਾਣੀ ਟਪਕਣਾ",
    detailsOptional: "ਵੇਰਵਾ (ਵਿਕਲਪਿਕ)",
    submittingBtn: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ…",
    submitRequestBtn: "ਰਿਕਵੈਸਟ ਭੇਜੋ",
    giveTitleError: "ਰਿਕਵੈਸਟ ਦਾ ਸਿਰਲੇਖ ਪਾਓ",
    requestRaisedToast: "ਰਿਕਵੈਸਟ ਭੇਜ ਦਿੱਤੀ ਗਈ",
    noRequestsYet: "ਹਾਲੇ ਤੱਕ ਕੋਈ ਰਿਕਵੈਸਟ ਨਹੀਂ ਭੇਜੀ ਗਈ।",
    noDetailsProvided: "ਕੋਈ ਵੇਰਵਾ ਨਹੀਂ ਦਿੱਤਾ ਗਿਆ",
    myVisitsHeading: "ਮੇਰੀਆਂ ਵਿਜ਼ਿਟ ਰਿਕਵੈਸਟਾਂ",
    emptyNoVisits: "ਤੁਸੀਂ ਹਾਲੇ ਤੱਕ ਕੋਈ ਪ੍ਰਾਪਰਟੀ ਵਿਜ਼ਿਟ ਰਿਕਵੈਸਟ ਨਹੀਂ ਭੇਜੀ।",
    visitLine: "{date} ਨੂੰ {time} ਵਜੇ",
    cancelVisitButton: "ਰੱਦ ਕਰੋ",
    visitCancelledToast: "ਵਿਜ਼ਿਟ ਰਿਕਵੈਸਟ ਰੱਦ ਕਰ ਦਿੱਤੀ ਗਈ",
    visitStatusPending: "ਬਾਕੀ",
    visitStatusConfirmed: "ਪੱਕੀ ਕੀਤੀ ਗਈ",
    visitStatusDeclined: "ਅਸਵੀਕਾਰ ਕੀਤੀ ਗਈ",
    visitStatusCancelled: "ਰੱਦ ਕੀਤੀ ਗਈ",
    vacateNoticeHeading: "ਖਾਲੀ ਕਰਨ ਦਾ ਨੋਟਿਸ",
    giveNoticeLink: "+ ਨੋਟਿਸ ਦਿਓ ›",
    vacateOnLabel: "{date} ਨੂੰ ਖਾਲੀ ਕੀਤਾ ਜਾਵੇਗਾ",
    noticeGivenOnLabel: "{date} ਨੂੰ ਨੋਟਿਸ ਦਿੱਤਾ ਗਿਆ",
    vacateStatusPending: "ਲੰਬਿਤ",
    vacateStatusAcknowledged: "ਮਨਜ਼ੂਰ",
    vacateStatusCancelled: "ਰੱਦ ਕੀਤੀ ਗਈ",
    shareWhatsappBtn: "💬 WhatsApp 'ਤੇ ਸ਼ੇਅਰ ਕਰੋ",
    cancelNoticeBtn: "ਨੋਟਿਸ ਰੱਦ ਕਰੋ",
    noticeDateLabel: "ਨੋਟਿਸ ਦੀ ਤਾਰੀਖ",
    vacateDatePreview: "ਤੁਹਾਡੀ {days}-ਦਿਨ ਦੀ ਨੋਟਿਸ ਮਿਆਦ ਮੁਤਾਬਕ, ਤੁਸੀਂ {date} ਨੂੰ ਖਾਲੀ ਕਰੋਗੇ",
    submitVacateNoticeBtn: "ਖਾਲੀ ਕਰਨ ਦਾ ਨੋਟਿਸ ਭੇਜੋ",
    vacateNoticeSentToast: "ਖਾਲੀ ਕਰਨ ਦਾ ਨੋਟਿਸ ਮਾਲਕ ਨੂੰ ਭੇਜ ਦਿੱਤਾ ਗਿਆ",
    vacateNoticeCancelledToast: "ਖਾਲੀ ਕਰਨ ਦਾ ਨੋਟਿਸ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ",
    emptyNoVacateNotices: "ਤੁਸੀਂ ਹਾਲੇ ਤੱਕ ਕੋਈ ਖਾਲੀ ਕਰਨ ਦਾ ਨੋਟਿਸ ਨਹੀਂ ਦਿੱਤਾ।",
    vacateWhatsappMessage: "ਹੈਲੋ {owner}, ਇਹ ਰਸਮੀ ਨੋਟਿਸ ਹੈ ਕਿ \"{property}\" ਨੂੰ {vacateDate} ਨੂੰ ਖਾਲੀ ਕੀਤਾ ਜਾਵੇਗਾ। ਨੋਟਿਸ {noticeDate} ਨੂੰ ਦਿੱਤਾ ਗਿਆ।",
  },
  tenantOnboarding: {
    title: "ਆਪਣਾ ਮੂਵ-ਇਨ ਪੂਰਾ ਕਰੋ",
    nameLabel: "ਤੁਹਾਡਾ ਨਾਮ (ਆਧਾਰ ਅਨੁਸਾਰ)",
    nameHint: "ਇਹੀ ਸਹੀ ਨਾਮ ਤੁਹਾਡੇ ਰੈਂਟਲ ਐਗਰੀਮੈਂਟ 'ਤੇ ਵਰਤਿਆ ਜਾਵੇਗਾ।",
    rentLabel: "ਮਾਸਿਕ ਕਿਰਾਇਆ",
    dueDayLabel: "ਕਿਰਾਇਆ ਭਰਨ ਦਾ ਦਿਨ",
    dueDayValue: "ਹਰ ਮਹੀਨੇ ਦੀ {day} ਤਾਰੀਖ",
    depositLabel: "ਸਿਕਿਓਰਿਟੀ ਡਿਪਾਜ਼ਿਟ",
    depositPaidBadge: "ਭੁਗਤਾਨ ਹੋਇਆ",
    depositPendingBadge: "ਬਕਾਇਆ",
    depositConfirmingBadge: "ਪੁਸ਼ਟੀ ਹੋ ਰਹੀ ਹੈ…",
    payNowBtn: "ਹੁਣੇ ਭਰੋ",
    payingBtn: "ਭੁਗਤਾਨ ਖੁੱਲ੍ਹ ਰਿਹਾ ਹੈ…",
    depositPaymentDesc: "ਸਿਕਿਓਰਿਟੀ ਡਿਪਾਜ਼ਿਟ",
    depositPaidToast: "ਡਿਪਾਜ਼ਿਟ ਭੁਗਤਾਨ ਮਿਲ ਗਿਆ",
    depositFailedToast: "ਭੁਗਤਾਨ ਨਹੀਂ ਹੋਇਆ — ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    depositPaidCashBadge: "ਨਕਦ ਵਿੱਚ ਭੁਗਤਾਨ ਕੀਤਾ",
    paidInCashLink: "ਮੈਂ ਨਕਦ ਭੁਗਤਾਨ ਕੀਤਾ",
    cashProofHint: "ਰਸੀਦ ਜਾਂ ਭੁਗਤਾਨ ਸਬੂਤ ਦੀ ਫੋਟੋ ਸ਼ਾਮਲ ਕਰੋ (ਵਿਕਲਪਿਕ)।",
    cashProofUploadLabel: "ਸਬੂਤ ਸ਼ਾਮਲ ਕਰੋ",
    confirmCashBtn: "ਨਕਦ ਭੁਗਤਾਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
    errDepositRequired: "ਅੱਗੇ ਵਧਣ ਤੋਂ ਪਹਿਲਾਂ ਸਿਕਿਓਰਿਟੀ ਡਿਪਾਜ਼ਿਟ ਭਰੋ (ਆਨਲਾਈਨ ਜਾਂ ਨਕਦ)",
    amenitiesLabel: "ਮਾਲਕ ਵੱਲੋਂ ਦਿੱਤੀਆਂ ਸੁਵਿਧਾਵਾਂ",
    identityVerificationLabel: "ਪਛਾਣ ਤਸਦੀਕ",
    yourIdentityLabel: "ਤੁਸੀਂ",
    identityVerificationHint: "ਤੁਹਾਡਾ ਸਰਕਾਰੀ-ਤਸਦੀਕਸ਼ੁਦਾ ਨਾਮ ਰੈਂਟਲ ਐਗਰੀਮੈਂਟ 'ਤੇ ਦਿਖਣ ਲਈ DigiLocker ਰਾਹੀਂ ਆਪਣੀ ਪਛਾਣ ਦੀ ਤਸਦੀਕ ਕਰੋ।",
    confirmLabel: "ਮੈਂ ਉੱਪਰ ਦਿੱਤੇ ਆਪਣੇ ਮੂਵ-ਇਨ ਵੇਰਵਿਆਂ ਦੀ ਸਮੀਖਿਆ ਕਰ ਲਈ ਹੈ ਅਤੇ ਪੁਸ਼ਟੀ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ ਕਿ ਇਹ ਸਹੀ ਹਨ।",
    submitBtn: "ਸੈੱਟਅੱਪ ਪੂਰਾ ਕਰੋ",
    errNameRequired: "ਆਪਣਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    errMustConfirm: "ਕਿਰਪਾ ਕਰਕੇ ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਤੁਸੀਂ ਵੇਰਵੇ ਦੇਖ ਲਏ ਹਨ",
    completedToast: "ਮੂਵ-ਇਨ ਵੇਰਵਿਆਂ ਦੀ ਪੁਸ਼ਟੀ ਹੋ ਗਈ",
  },
  moveInDetails: {
    title: "ਮੂਵ-ਇਨ ਵੇਰਵੇ",
  },
  locationCapture: {
    pinLocationLabel: "ਇਸ ਪ੍ਰਾਪਰਟੀ ਦੀ ਲੋਕੇਸ਼ਨ ਪਿਨ ਕਰੋ",
    panMapHint: "📌 ਸਹੀ ਥਾਂ 'ਤੇ ਪਿਨ ਰੱਖਣ ਲਈ ਨਕਸ਼ੇ ਨੂੰ ਹਿਲਾਓ",
    expandMapAria: "ਨਕਸ਼ਾ ਵੱਡਾ ਕਰੋ",
    clear: "ਹਟਾਓ",
    searchPlaceholder: "ਪਤਾ ਖੋਜੋ",
    loadingSearch: "ਖੋਜ ਲੋਡ ਹੋ ਰਹੀ ਹੈ…",
    or: "ਜਾਂ",
    locating: "ਲੋਕੇਸ਼ਨ ਲੱਭੀ ਜਾ ਰਹੀ ਹੈ…",
    useCurrentLocation: "📍 ਮੌਜੂਦਾ ਲੋਕੇਸ਼ਨ ਵਰਤੋ",
    pickSuggestion: "ਡ੍ਰੌਪਡਾਊਨ ਤੋਂ ਕੋਈ ਸੁਝਾਅ ਚੁਣੋ",
    locationNotSupported: "ਇਸ ਬ੍ਰਾਊਜ਼ਰ ਵਿੱਚ ਲੋਕੇਸ਼ਨ ਸਪੋਰਟ ਨਹੀਂ ਹੈ",
    locationPermissionDenied: "ਲੋਕੇਸ਼ਨ ਦੀ ਇਜਾਜ਼ਤ ਨਹੀਂ ਮਿਲੀ",
    locationCouldNotGet: "ਤੁਹਾਡੀ ਲੋਕੇਸ਼ਨ ਨਹੀਂ ਮਿਲ ਸਕੀ",
    hint: "ਪਤਾ ਖੋਜੋ ਜਾਂ ਹੇਠਾਂ ਇਲਾਕਾ ਆਪਣੇ ਆਪ ਭਰਨ ਲਈ GPS 'ਤੇ ਟੈਪ ਕਰੋ — ਦਰਵਾਜ਼ੇ ਦਾ ਨੰਬਰ ਅਤੇ ਬਿਲਡਿੰਗ ਦਾ ਨਾਂ ਤੁਹਾਨੂੰ ਖੁਦ ਪਾਉਣਾ ਹੋਵੇਗਾ।",
  },
  googleMap: {
    yourLocation: "ਤੁਹਾਡੀ ਲੋਕੇਸ਼ਨ",
    couldNotLoad: "Google Maps ਲੋਡ ਨਹੀਂ ਹੋ ਸਕਿਆ — API ਕੀ ਚੈੱਕ ਕਰੋ",
    viewDetails: "ਵੇਰਵੇ ਦੇਖੋ ›",
  },
  rentReceipt: {
    back: "‹ ਵਾਪਸ",
    paymentRecordedBanner: "✓ ਭੁਗਤਾਨ ਦਰਜ ਹੋ ਗਿਆ — ਇਹ ਰਹੀ ਤੁਹਾਡੀ ਰਸੀਦ।",
    title: "ਕਿਰਾਇਆ ਰਸੀਦ",
    amountPaid: "ਭੁਗਤਾਨ ਕੀਤੀ ਗਈ ਰਕਮ",
    receiptNoLabel: "ਰਸੀਦ ਨੰਬਰ",
    paidByLabel: "ਭੁਗਤਾਨ ਕਰਤਾ",
    propertyLabel: "ਪ੍ਰਾਪਰਟੀ",
    receivedByLabel: "ਪ੍ਰਾਪਤ ਕਰਤਾ",
    forMonthLabel: "ਕਿਸ ਮਹੀਨੇ ਲਈ",
    paymentModeLabel: "ਭੁਗਤਾਨ ਦਾ ਤਰੀਕਾ",
    paidOnLabel: "ਭੁਗਤਾਨ ਦੀ ਤਾਰੀਖ",
    downloadBtn: "ਡਾਊਨਲੋਡ ਕਰੋ",
    shareBtn: "ਸ਼ੇਅਰ ਕਰੋ",
    htmlTitle: "ਕਿਰਾਇਆ ਰਸੀਦ - {month}",
    htmlStamp: "✓ ਭੁਗਤਾਨ ਹੋਇਆ",
    htmlAmountPaidLabel: "ਭੁਗਤਾਨ ਕੀਤੀ ਗਈ ਰਕਮ",
    htmlFooter: "ਇਹ ToLetBook ਵੱਲੋਂ ਸਿਸਟਮ-ਜਨਰੇਟਿਡ ਰਸੀਦ ਹੈ। ਇੱਥੇ ਦਿਖਾਇਆ ਗਿਆ ਕਿਰਾਇਆ ਐਪ ਦੇ ਅੰਦਰ ਦਰਜ ਕੀਤਾ ਗਿਆ ਹੈ ਅਤੇ ਕਿਸੇ ਅਸਲੀ ਪੇਮੈਂਟ ਗੇਟਵੇ ਰਾਹੀਂ ਪ੍ਰੋਸੈਸ ਨਹੀਂ ਹੋਇਆ।",
    shareTitle: "ਕਿਰਾਇਆ ਰਸੀਦ - {month}",
    shareText: "ਰਸੀਦ {receiptNo}, ਰਕਮ {amount}",
  },
  rentalAgreement: {
    back: "‹ ਵਾਪਸ",
    title: "ਰੈਂਟਲ ਐਗਰੀਮੈਂਟ",
    ownerLabel: "ਮਾਲਕ",
    tenantLabel: "ਕਿਰਾਏਦਾਰ",
    propertyLabel: "ਪ੍ਰਾਪਰਟੀ",
    typeLabel: "ਟਾਈਪ",
    monthlyRentLabel: "ਮਾਸਿਕ ਕਿਰਾਇਆ",
    securityDepositLabel: "ਸਿਕਿਓਰਿਟੀ ਡਿਪਾਜ਼ਿਟ",
    moveInDateLabel: "ਸ਼ਿਫਟਿੰਗ ਦੀ ਤਾਰੀਖ",
    disclaimer: "ਇਹ ਰਿਕਾਰਡ ਵਿੱਚ ਮੌਜੂਦ ਟੈਨੈਂਸੀ ਜਾਣਕਾਰੀ ਤੋਂ ਆਪਣੇ ਆਪ ਬਣਿਆ ਸਾਰ ਹੈ, ਕੋਈ ਕਾਨੂੰਨੀ ਤੌਰ 'ਤੇ ਬਾਈਡਿੰਗ ਦਸਤਾਵੇਜ਼ ਨਹੀਂ ਹੈ। ਡੈਮੋ ਦੀਆਂ ਆਮ ਸ਼ਰਤਾਂ: ਕਿਰਾਇਆ ਹਰ ਮਹੀਨੇ ਦੀ 5 ਤਾਰੀਖ ਤੱਕ ਦੇਣਾ ਹੈ, ਟੈਨੈਂਸੀ ਖਤਮ ਕਰਨ ਲਈ 30 ਦਿਨ ਦਾ ਨੋਟਿਸ, ਡਿਪਾਜ਼ਿਟ ਆਮ ਟੁੱਟ-ਭੱਜ ਤੋਂ ਵੱਧ ਨੁਕਸਾਨ ਦੀ ਕਟੌਤੀ ਤੋਂ ਬਾਅਦ ਵਾਪਸ ਮਿਲੇਗਾ।",
    downloadAgreementBtn: "ਐਗਰੀਮੈਂਟ ਡਾਊਨਲੋਡ ਕਰੋ",
    stampStatusLabel: "E-Stamp ਸਟੇਟਸ",
    stampStatusNotStarted: "ਸ਼ੁਰੂ ਨਹੀਂ ਹੋਇਆ",
    stampStatusProcessing: "ਪ੍ਰੋਸੈਸ ਹੋ ਰਿਹਾ ਹੈ",
    stampStatusVerified: "ਵੈਰੀਫਾਈਡ",
    stampHint: "ਇਸ ਐਗਰੀਮੈਂਟ ਨੂੰ ਸਰਕਾਰ ਤੋਂ ਕਾਨੂੰਨੀ ਤੌਰ 'ਤੇ E-Stamp ਕਰਵਾਓ। ਇਸ ਲਈ {amount} ਦੀ ਅਸਲੀ ਸਰਕਾਰੀ ਫੀਸ ਲੱਗੇਗੀ।",
    stampFeeAlreadyPaidHint: "ਤੁਹਾਡੀ E-Stamp ਫੀਸ ਭਰੀ ਜਾ ਚੁੱਕੀ ਹੈ — ਬੱਸ ਆਰਡਰ ਅਜੇ ਨਹੀਂ ਭੇਜਿਆ ਜਾ ਸਕਿਆ। ਬਿਨਾਂ ਕਿਸੇ ਵਾਧੂ ਖਰਚੇ ਦੇ ਹੇਠਾਂ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    sendForStampBtn: "{amount} ਭਰੋ ਅਤੇ E-Stamp ਲਈ ਭੇਜੋ",
    retrySendForStampBtn: "E-Stamp ਲਈ ਦੁਬਾਰਾ ਭੇਜੋ",
    sendingStampBtn: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ…",
    confirmingPaymentBtn: "ਭੁਗਤਾਨ ਦੀ ਪੁਸ਼ਟੀ ਹੋ ਰਹੀ ਹੈ…",
    stampFeePaymentDesc: "ਸਰਕਾਰੀ E-Stamp ਫੀਸ",
    stampFeeFailedToast: "ਭੁਗਤਾਨ ਅਸਫਲ ਹੋਇਆ — ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    stampSentToast: "ਸਰਕਾਰੀ E-Stamping ਲਈ ਭੇਜ ਦਿੱਤਾ ਗਿਆ",
    refreshStatusBtn: "ਸਟੇਟਸ ਰਿਫਰੈਸ਼ ਕਰੋ",
    viewStampedBtn: "ਸਟੈਂਪਡ ਐਗਰੀਮੈਂਟ ਦੇਖੋ",
    identityVerificationLabel: "ਪਛਾਣ ਤਸਦੀਕ",
    digilockerVerifiedBadge: "ਤਸਦੀਕ ਹੋਇਆ",
    digilockerNotVerifiedBadge: "ਤਸਦੀਕ ਨਹੀਂ ਹੋਇਆ",
    verifyDigilockerBtn: "DigiLocker ਨਾਲ ਤਸਦੀਕ ਕਰੋ",
    verifyingDigilockerBtn: "DigiLocker ਖੁੱਲ੍ਹ ਰਿਹਾ ਹੈ…",
    digilockerVerifiedToast: "{name} ਵਜੋਂ ਤਸਦੀਕ ਹੋਇਆ",
    digilockerDeniedToast: "DigiLocker ਤਸਦੀਕ ਰੱਦ ਕਰ ਦਿੱਤੀ ਗਈ",
    digilockerExpiredToast: "ਉਹ DigiLocker ਲਿੰਕ ਦੀ ਮਿਆਦ ਖਤਮ ਹੋ ਗਈ — ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    comingSoonTitle: "ਸਰਕਾਰੀ ਈ-ਸਟੈਂਪਿੰਗ ਜਲਦੀ ਆ ਰਹੀ ਹੈ",
    comingSoonBody: "ਅਸੀਂ ਸਟੈਂਪ ਡਿਊਟੀ ਭੁਗਤਾਨ ਸੈੱਟਅੱਪ ਕਰ ਰਹੇ ਹਾਂ ਤਾਂ ਜੋ ਤੁਸੀਂ ਐਪ ਤੋਂ ਹੀ ਪੂਰੀ ਤਰ੍ਹਾਂ ਸਰਕਾਰ-ਪ੍ਰਮਾਣਿਤ, ਈ-ਸਟੈਂਪਡ ਕਿਰਾਇਆ ਸਮਝੌਤਾ ਬਣਾ ਸਕੋ।",
    interestBtn: "ਮੈਨੂੰ ਦਿਲਚਸਪੀ ਹੈ — ਸੂਚਿਤ ਕਰੋ",
    interestRegisteredBtn: "ਤੁਸੀਂ ਸੂਚੀ ਵਿੱਚ ਹੋ ✓",
    interestToast: "ਧੰਨਵਾਦ! ਈ-ਸਟੈਂਪਿੰਗ ਲਾਈਵ ਹੋਣ 'ਤੇ ਅਸੀਂ ਤੁਹਾਨੂੰ ਸੂਚਿਤ ਕਰਾਂਗੇ।",
    uploadDocHeading: "ਪਹਿਲਾਂ ਹੀ ਕਿਰਾਇਆ ਸਮਝੌਤਾ ਹੈ?",
    uploadDocHint: "ਜੇ ਤੁਸੀਂ ToLetBook ਤੋਂ ਬਾਹਰ ਪਹਿਲਾਂ ਹੀ ਇੱਕ ਬਣਾਇਆ ਹੈ, ਤਾਂ ਇਸ ਕਿਰਾਏਦਾਰੀ ਨਾਲ ਸੇਵ ਹੋਣ ਲਈ ਇੱਥੇ ਅੱਪਲੋਡ ਕਰੋ।",
    uploadDocBtn: "ਕਿਰਾਇਆ ਸਮਝੌਤਾ ਅੱਪਲੋਡ ਕਰੋ",
    viewUploadedDocBtn: "ਅੱਪਲੋਡ ਕੀਤਾ ਸਮਝੌਤਾ ਦੇਖੋ",
    removeUploadedDocBtn: "ਹਟਾਓ",
    uploadedOnLabel: "{date} ਨੂੰ ਅੱਪਲੋਡ ਕੀਤਾ ਗਿਆ",
    noUploadedDocTenantHint: "ਤੁਹਾਡੇ ਮਾਲਕ ਨੇ ਅਜੇ ਤੱਕ ਕਿਰਾਇਆ ਸਮਝੌਤਾ ਅੱਪਲੋਡ ਨਹੀਂ ਕੀਤਾ।",
    uploadDocSuccessToast: "ਕਿਰਾਇਆ ਸਮਝੌਤਾ ਅੱਪਲੋਡ ਹੋ ਗਿਆ",
    uploadDocFailedToast: "ਅੱਪਲੋਡ ਨਹੀਂ ਹੋ ਸਕਿਆ — 8MB ਤੋਂ ਘੱਟ ਦੀ PDF ਜਾਂ ਤਸਵੀਰ ਅਜ਼ਮਾਓ",
    removeDocConfirm: "ਅੱਪਲੋਡ ਕੀਤਾ ਕਿਰਾਇਆ ਸਮਝੌਤਾ ਹਟਾਉਣਾ ਹੈ?",
    removeDocSuccessToast: "ਕਿਰਾਇਆ ਸਮਝੌਤਾ ਹਟਾ ਦਿੱਤਾ ਗਿਆ",
    htmlTitle: "ਰੈਂਟਲ ਐਗਰੀਮੈਂਟ - {property}",
    htmlDocTitle: "ਰੈਂਟਲ ਐਗਰੀਮੈਂਟ ਸਾਰ",
    htmlAgreementNo: "ਐਗਰੀਮੈਂਟ ਨੰਬਰ {no}",
    htmlOwnerLessor: "ਮਾਲਕ / ਲੈਸਰ",
    htmlTenantLessee: "ਕਿਰਾਏਦਾਰ / ਲੈਸੀ",
    htmlPropertyHeading: "ਪ੍ਰਾਪਰਟੀ",
    htmlAddressLabel: "ਪਤਾ",
    htmlTypeLabel: "ਟਾਈਪ",
    htmlTermsHeading: "ਸ਼ਰਤਾਂ",
    htmlMonthlyRentLabel: "ਮਾਸਿਕ ਕਿਰਾਇਆ",
    htmlSecurityDepositLabel: "ਸਿਕਿਓਰਿਟੀ ਡਿਪਾਜ਼ਿਟ",
    htmlMoveInDateLabel: "ਸ਼ਿਫਟਿੰਗ ਦੀ ਤਾਰੀਖ",
    htmlConditionsHeading: "ਨਿਯਮ",
    htmlCond1: "ਕਿਰਾਇਆ ਹਰ ਮਹੀਨੇ ਦੀ 5 ਤਾਰੀਖ ਤੱਕ, ਤੈਅ ਕੀਤੇ ਤਰੀਕੇ ਨਾਲ ਮਾਲਕ ਨੂੰ ਦੇਣਾ ਹੈ।",
    htmlCond2: "ਆਮ ਟੁੱਟ-ਭੱਜ ਤੋਂ ਵੱਧ ਨੁਕਸਾਨ ਦੀ ਕਟੌਤੀ ਤੋਂ ਬਾਅਦ, ਸ਼ਿਫਟ ਹੋਣ ਵੇਲੇ ਸਿਕਿਓਰਿਟੀ ਡਿਪਾਜ਼ਿਟ ਵਾਪਸ ਮਿਲੇਗਾ।",
    htmlCond3: "ਟੈਨੈਂਸੀ ਖਤਮ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਦੋਵਾਂ ਵਿੱਚੋਂ ਕਿਸੇ ਵੀ ਧਿਰ ਨੂੰ ਘੱਟੋ-ਘੱਟ 30 ਦਿਨ ਦਾ ਲਿਖਤੀ ਨੋਟਿਸ ਦੇਣਾ ਹੋਵੇਗਾ।",
    htmlCond4: "ਜਦੋਂ ਤੱਕ ਮਾਲਕ ਨਾਲ ਵੱਖਰੀ ਸਹਿਮਤੀ ਨਾ ਹੋਵੇ, ਯੂਟਿਲਿਟੀ ਬਿੱਲਾਂ ਦੀ ਜ਼ਿੰਮੇਵਾਰੀ ਕਿਰਾਏਦਾਰ ਦੀ ਹੋਵੇਗੀ।",
    htmlCond5: "ਫਿਕਸਚਰ ਅਤੇ ਫਿਟਿੰਗਸ ਦੇ ਰੱਖ-ਰਖਾਅ ਦੀ ਜ਼ਿੰਮੇਵਾਰੀ ਮਾਲਕ ਦੀ ਹੈ, ਜਦੋਂ ਤੱਕ ਨੁਕਸਾਨ ਕਿਰਾਏਦਾਰ ਦੀ ਲਾਪਰਵਾਹੀ ਨਾਲ ਨਾ ਹੋਇਆ ਹੋਵੇ।",
    htmlFooter: "ਇਹ ਸਾਰ ToLetBook ਵੱਲੋਂ ਰਿਕਾਰਡ ਵਿੱਚ ਮੌਜੂਦ ਟੈਨੈਂਸੀ ਜਾਣਕਾਰੀ ਤੋਂ ਆਪਣੇ ਆਪ ਬਣਾਇਆ ਗਿਆ ਹੈ ਅਤੇ ਇਹ ਕੋਈ ਕਾਨੂੰਨੀ ਤੌਰ 'ਤੇ ਬਾਈਡਿੰਗ ਦਸਤਾਵੇਜ਼ ਨਹੀਂ ਹੈ। ਰਸਮੀ ਰੈਂਟਲ ਐਗਰੀਮੈਂਟ ਬਣਾਉਣ ਲਈ ਕਿਸੇ ਕਾਨੂੰਨੀ ਮਾਹਿਰ ਨਾਲ ਸਲਾਹ ਕਰੋ।",
  },
  photoLightbox: {
    closeAria: "ਬੰਦ ਕਰੋ",
    previousPhotoAria: "ਪਿਛਲੀ ਫੋਟੋ",
    nextPhotoAria: "ਅਗਲੀ ਫੋਟੋ",
    countLabel: "{current} / {total}",
  },
  tenantPlan: {
    title: "ਪਲਾਨ",
    currentPlanLabel: "ਮੌਜੂਦਾ ਪਲਾਨ",
    basicName: "ਬੇਸਿਕ",
    proName: "ਕਿਰਾਏਦਾਰ ਪ੍ਰੋ",
    proSub: "ਸਰਗਰਮੀ ਨਾਲ ਘਰ ਲੱਭ ਰਹੇ ਕਿਰਾਏਦਾਰਾਂ ਲਈ",
    priceValidity: "1 ਮਹੀਨੇ ਲਈ ਵੈਧ",
    featUnlock: "30 ਦਿਨਾਂ ਲਈ ਅਸੀਮਤ ਮਾਲਕ ਸੰਪਰਕ ਨੰਬਰ ਅਨਲੌਕ ਕਰੋ",
    featNearby: "ਹਰ ਲਿਸਟਿੰਗ 'ਤੇ ਪੂਰਾ ਨਕਸ਼ਾ ਅਤੇ ਨੇੜਲੀਆਂ-ਥਾਵਾਂ ਦੀ ਪਹੁੰਚ",
    featWhatsapp: "ਮਾਲਕ ਨਾਲ ਸਿੱਧਾ WhatsApp 'ਤੇ ਗੱਲ ਕਰੋ, ਪ੍ਰਤੀ-ਲਿਸਟਿੰਗ ਕੋਈ ਫੀਸ ਨਹੀਂ",
    featFallback: "ਸਬਸਕ੍ਰਾਈਬ ਨਾ ਕਰਨ 'ਤੇ ਵੀ 1 ਮਾਲਕ ਦਾ ਕਾਂਟੈਕਟ ਮੁਫ਼ਤ ਅਨਲੌਕ ਮਿਲਦਾ ਹੈ — ਇਸ ਤੋਂ ਬਾਅਦ ਅੱਪਗ੍ਰੇਡ ਕਰਨਾ ਹੋਵੇਗਾ",
    currentPlanBtn: "ਮੌਜੂਦਾ ਪਲਾਨ",
    subscribeBtn: "₹99 ਵਿੱਚ ਸਬਸਕ੍ਰਾਈਬ ਕਰੋ",
    activeUntil: "{date} ਤੱਕ ਐਕਟਿਵ",
    noChargeNote: "ਹਾਲੇ ਕੋਈ ਭੁਗਤਾਨ ਲੋੜੀਂਦਾ ਨਹੀਂ — ਬਿਲਿੰਗ ਸੈੱਟ ਹੋਣ ਤੱਕ ਸਬਸਕ੍ਰਾਈਬ ਕਰਨਾ ਮੁਫ਼ਤ ਹੈ।",
    subscribedToast: "ਕਿਰਾਏਦਾਰ ਪ੍ਰੋ ਐਕਟਿਵੇਟ ਹੋ ਗਿਆ",
    switchFailedToast: "ਤੁਹਾਡਾ ਪਲਾਨ ਅੱਪਡੇਟ ਨਹੀਂ ਹੋ ਸਕਿਆ",
    nearbyUpsellTitle: "ਨਕਸ਼ਾ ਅਤੇ ਨੇੜਲੀਆਂ ਥਾਵਾਂ ਅਨਲੌਕ ਕਰੋ",
    nearbyUpsellBody: "ਹਰ ਲਿਸਟਿੰਗ ਦੇ ਨੇੜੇ ਟਰਾਂਜ਼ਿਟ, ਜ਼ਰੂਰੀ ਚੀਜ਼ਾਂ ਅਤੇ ਸਿਹਤ ਸੇਵਾਵਾਂ ਦੇਖਣ ਲਈ ਕਿਰਾਏਦਾਰ ਪ੍ਰੋ ਸਬਸਕ੍ਰਾਈਬ ਕਰੋ।",
    nearbyUpsellBtn: "ਕਿਰਾਏਦਾਰ ਪ੍ਰੋ ਦੇਖੋ",
    cancelPlanBtn: "ਪਲਾਨ ਰੱਦ ਕਰੋ",
    securePaymentNote: "ਭੁਗਤਾਨ Razorpay ਰਾਹੀਂ ਸੁਰੱਖਿਅਤ ਢੰਗ ਨਾਲ ਪ੍ਰੋਸੈਸ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
    cancelledToast: "ਕਿਰਾਏਦਾਰ ਪ੍ਰੋ ਰੱਦ ਕੀਤਾ ਗਿਆ",
  },
};
